var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { forwardRef } from 'react';
import AcademicCapIconOutlineOriginal from '@heroicons/react/24/outline/AcademicCapIcon';
export const AcademicCapIconOutline = forwardRef(function AcademicCapIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AcademicCapIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AdjustmentsHorizontalIconOutlineOriginal from '@heroicons/react/24/outline/AdjustmentsHorizontalIcon';
export const AdjustmentsHorizontalIconOutline = forwardRef(function AdjustmentsHorizontalIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AdjustmentsHorizontalIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AdjustmentsVerticalIconOutlineOriginal from '@heroicons/react/24/outline/AdjustmentsVerticalIcon';
export const AdjustmentsVerticalIconOutline = forwardRef(function AdjustmentsVerticalIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AdjustmentsVerticalIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/ArchiveBoxArrowDownIcon';
export const ArchiveBoxArrowDownIconOutline = forwardRef(function ArchiveBoxArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxXMarkIconOutlineOriginal from '@heroicons/react/24/outline/ArchiveBoxXMarkIcon';
export const ArchiveBoxXMarkIconOutline = forwardRef(function ArchiveBoxXMarkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxXMarkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxIconOutlineOriginal from '@heroicons/react/24/outline/ArchiveBoxIcon';
export const ArchiveBoxIconOutline = forwardRef(function ArchiveBoxIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownCircleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownCircleIcon';
export const ArrowDownCircleIconOutline = forwardRef(function ArrowDownCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownLeftIcon';
export const ArrowDownLeftIconOutline = forwardRef(function ArrowDownLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownOnSquareStackIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownOnSquareStackIcon';
export const ArrowDownOnSquareStackIconOutline = forwardRef(function ArrowDownOnSquareStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownOnSquareStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownOnSquareIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownOnSquareIcon';
export const ArrowDownOnSquareIconOutline = forwardRef(function ArrowDownOnSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownOnSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownRightIcon';
export const ArrowDownRightIconOutline = forwardRef(function ArrowDownRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownTrayIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownTrayIcon';
export const ArrowDownTrayIconOutline = forwardRef(function ArrowDownTrayIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownTrayIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowDownIcon';
export const ArrowDownIconOutline = forwardRef(function ArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftCircleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLeftCircleIcon';
export const ArrowLeftCircleIconOutline = forwardRef(function ArrowLeftCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftEndOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLeftEndOnRectangleIcon';
export const ArrowLeftEndOnRectangleIconOutline = forwardRef(function ArrowLeftEndOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftEndOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLeftOnRectangleIcon';
export const ArrowLeftOnRectangleIconOutline = forwardRef(function ArrowLeftOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftStartOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLeftStartOnRectangleIcon';
export const ArrowLeftStartOnRectangleIconOutline = forwardRef(function ArrowLeftStartOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftStartOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLeftIcon';
export const ArrowLeftIconOutline = forwardRef(function ArrowLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLongDownIcon';
export const ArrowLongDownIconOutline = forwardRef(function ArrowLongDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLongLeftIcon';
export const ArrowLongLeftIconOutline = forwardRef(function ArrowLongLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLongRightIcon';
export const ArrowLongRightIconOutline = forwardRef(function ArrowLongRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowLongUpIcon';
export const ArrowLongUpIconOutline = forwardRef(function ArrowLongUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowPathRoundedSquareIconOutlineOriginal from '@heroicons/react/24/outline/ArrowPathRoundedSquareIcon';
export const ArrowPathRoundedSquareIconOutline = forwardRef(function ArrowPathRoundedSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowPathRoundedSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowPathIconOutlineOriginal from '@heroicons/react/24/outline/ArrowPathIcon';
export const ArrowPathIconOutline = forwardRef(function ArrowPathIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowPathIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightCircleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowRightCircleIcon';
export const ArrowRightCircleIconOutline = forwardRef(function ArrowRightCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightEndOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowRightEndOnRectangleIcon';
export const ArrowRightEndOnRectangleIconOutline = forwardRef(function ArrowRightEndOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightEndOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowRightOnRectangleIcon';
export const ArrowRightOnRectangleIconOutline = forwardRef(function ArrowRightOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightStartOnRectangleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowRightStartOnRectangleIcon';
export const ArrowRightStartOnRectangleIconOutline = forwardRef(function ArrowRightStartOnRectangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightStartOnRectangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowRightIcon';
export const ArrowRightIconOutline = forwardRef(function ArrowRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowSmallDownIcon';
export const ArrowSmallDownIconOutline = forwardRef(function ArrowSmallDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowSmallLeftIcon';
export const ArrowSmallLeftIconOutline = forwardRef(function ArrowSmallLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowSmallRightIcon';
export const ArrowSmallRightIconOutline = forwardRef(function ArrowSmallRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowSmallUpIcon';
export const ArrowSmallUpIconOutline = forwardRef(function ArrowSmallUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTopRightOnSquareIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTopRightOnSquareIcon';
export const ArrowTopRightOnSquareIconOutline = forwardRef(function ArrowTopRightOnSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTopRightOnSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTrendingDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTrendingDownIcon';
export const ArrowTrendingDownIconOutline = forwardRef(function ArrowTrendingDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTrendingDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTrendingUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTrendingUpIcon';
export const ArrowTrendingUpIconOutline = forwardRef(function ArrowTrendingUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTrendingUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnDownLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnDownLeftIcon';
export const ArrowTurnDownLeftIconOutline = forwardRef(function ArrowTurnDownLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnDownLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnDownRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnDownRightIcon';
export const ArrowTurnDownRightIconOutline = forwardRef(function ArrowTurnDownRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnDownRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnLeftDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnLeftDownIcon';
export const ArrowTurnLeftDownIconOutline = forwardRef(function ArrowTurnLeftDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnLeftDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnLeftUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnLeftUpIcon';
export const ArrowTurnLeftUpIconOutline = forwardRef(function ArrowTurnLeftUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnLeftUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnRightDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnRightDownIcon';
export const ArrowTurnRightDownIconOutline = forwardRef(function ArrowTurnRightDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnRightDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnRightUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnRightUpIcon';
export const ArrowTurnRightUpIconOutline = forwardRef(function ArrowTurnRightUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnRightUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnUpLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnUpLeftIcon';
export const ArrowTurnUpLeftIconOutline = forwardRef(function ArrowTurnUpLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnUpLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnUpRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowTurnUpRightIcon';
export const ArrowTurnUpRightIconOutline = forwardRef(function ArrowTurnUpRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnUpRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpCircleIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpCircleIcon';
export const ArrowUpCircleIconOutline = forwardRef(function ArrowUpCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpLeftIcon';
export const ArrowUpLeftIconOutline = forwardRef(function ArrowUpLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpOnSquareStackIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpOnSquareStackIcon';
export const ArrowUpOnSquareStackIconOutline = forwardRef(function ArrowUpOnSquareStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpOnSquareStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpOnSquareIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpOnSquareIcon';
export const ArrowUpOnSquareIconOutline = forwardRef(function ArrowUpOnSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpOnSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpRightIcon';
export const ArrowUpRightIconOutline = forwardRef(function ArrowUpRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpTrayIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpTrayIcon';
export const ArrowUpTrayIconOutline = forwardRef(function ArrowUpTrayIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpTrayIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUpIcon';
export const ArrowUpIconOutline = forwardRef(function ArrowUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUturnDownIcon';
export const ArrowUturnDownIconOutline = forwardRef(function ArrowUturnDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUturnLeftIcon';
export const ArrowUturnLeftIconOutline = forwardRef(function ArrowUturnLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnRightIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUturnRightIcon';
export const ArrowUturnRightIconOutline = forwardRef(function ArrowUturnRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnUpIconOutlineOriginal from '@heroicons/react/24/outline/ArrowUturnUpIcon';
export const ArrowUturnUpIconOutline = forwardRef(function ArrowUturnUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsPointingInIconOutlineOriginal from '@heroicons/react/24/outline/ArrowsPointingInIcon';
export const ArrowsPointingInIconOutline = forwardRef(function ArrowsPointingInIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsPointingInIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsPointingOutIconOutlineOriginal from '@heroicons/react/24/outline/ArrowsPointingOutIcon';
export const ArrowsPointingOutIconOutline = forwardRef(function ArrowsPointingOutIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsPointingOutIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsRightLeftIconOutlineOriginal from '@heroicons/react/24/outline/ArrowsRightLeftIcon';
export const ArrowsRightLeftIconOutline = forwardRef(function ArrowsRightLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsRightLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsUpDownIconOutlineOriginal from '@heroicons/react/24/outline/ArrowsUpDownIcon';
export const ArrowsUpDownIconOutline = forwardRef(function ArrowsUpDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsUpDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AtSymbolIconOutlineOriginal from '@heroicons/react/24/outline/AtSymbolIcon';
export const AtSymbolIconOutline = forwardRef(function AtSymbolIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AtSymbolIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BackspaceIconOutlineOriginal from '@heroicons/react/24/outline/BackspaceIcon';
export const BackspaceIconOutline = forwardRef(function BackspaceIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BackspaceIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BackwardIconOutlineOriginal from '@heroicons/react/24/outline/BackwardIcon';
export const BackwardIconOutline = forwardRef(function BackwardIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BackwardIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BanknotesIconOutlineOriginal from '@heroicons/react/24/outline/BanknotesIcon';
export const BanknotesIconOutline = forwardRef(function BanknotesIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BanknotesIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars2IconOutlineOriginal from '@heroicons/react/24/outline/Bars2Icon';
export const Bars2IconOutline = forwardRef(function Bars2IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars2IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3BottomLeftIconOutlineOriginal from '@heroicons/react/24/outline/Bars3BottomLeftIcon';
export const Bars3BottomLeftIconOutline = forwardRef(function Bars3BottomLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3BottomLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3BottomRightIconOutlineOriginal from '@heroicons/react/24/outline/Bars3BottomRightIcon';
export const Bars3BottomRightIconOutline = forwardRef(function Bars3BottomRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3BottomRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3CenterLeftIconOutlineOriginal from '@heroicons/react/24/outline/Bars3CenterLeftIcon';
export const Bars3CenterLeftIconOutline = forwardRef(function Bars3CenterLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3CenterLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3IconOutlineOriginal from '@heroicons/react/24/outline/Bars3Icon';
export const Bars3IconOutline = forwardRef(function Bars3IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars4IconOutlineOriginal from '@heroicons/react/24/outline/Bars4Icon';
export const Bars4IconOutline = forwardRef(function Bars4IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars4IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BarsArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/BarsArrowDownIcon';
export const BarsArrowDownIconOutline = forwardRef(function BarsArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BarsArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BarsArrowUpIconOutlineOriginal from '@heroicons/react/24/outline/BarsArrowUpIcon';
export const BarsArrowUpIconOutline = forwardRef(function BarsArrowUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BarsArrowUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery0IconOutlineOriginal from '@heroicons/react/24/outline/Battery0Icon';
export const Battery0IconOutline = forwardRef(function Battery0IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery0IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery100IconOutlineOriginal from '@heroicons/react/24/outline/Battery100Icon';
export const Battery100IconOutline = forwardRef(function Battery100IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery100IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery50IconOutlineOriginal from '@heroicons/react/24/outline/Battery50Icon';
export const Battery50IconOutline = forwardRef(function Battery50IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery50IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BeakerIconOutlineOriginal from '@heroicons/react/24/outline/BeakerIcon';
export const BeakerIconOutline = forwardRef(function BeakerIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BeakerIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellAlertIconOutlineOriginal from '@heroicons/react/24/outline/BellAlertIcon';
export const BellAlertIconOutline = forwardRef(function BellAlertIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellAlertIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellSlashIconOutlineOriginal from '@heroicons/react/24/outline/BellSlashIcon';
export const BellSlashIconOutline = forwardRef(function BellSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellSnoozeIconOutlineOriginal from '@heroicons/react/24/outline/BellSnoozeIcon';
export const BellSnoozeIconOutline = forwardRef(function BellSnoozeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellSnoozeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellIconOutlineOriginal from '@heroicons/react/24/outline/BellIcon';
export const BellIconOutline = forwardRef(function BellIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoldIconOutlineOriginal from '@heroicons/react/24/outline/BoldIcon';
export const BoldIconOutline = forwardRef(function BoldIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoldIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoltSlashIconOutlineOriginal from '@heroicons/react/24/outline/BoltSlashIcon';
export const BoltSlashIconOutline = forwardRef(function BoltSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoltSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoltIconOutlineOriginal from '@heroicons/react/24/outline/BoltIcon';
export const BoltIconOutline = forwardRef(function BoltIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoltIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookOpenIconOutlineOriginal from '@heroicons/react/24/outline/BookOpenIcon';
export const BookOpenIconOutline = forwardRef(function BookOpenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookOpenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkSlashIconOutlineOriginal from '@heroicons/react/24/outline/BookmarkSlashIcon';
export const BookmarkSlashIconOutline = forwardRef(function BookmarkSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkSquareIconOutlineOriginal from '@heroicons/react/24/outline/BookmarkSquareIcon';
export const BookmarkSquareIconOutline = forwardRef(function BookmarkSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkIconOutlineOriginal from '@heroicons/react/24/outline/BookmarkIcon';
export const BookmarkIconOutline = forwardRef(function BookmarkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BriefcaseIconOutlineOriginal from '@heroicons/react/24/outline/BriefcaseIcon';
export const BriefcaseIconOutline = forwardRef(function BriefcaseIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BriefcaseIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BugAntIconOutlineOriginal from '@heroicons/react/24/outline/BugAntIcon';
export const BugAntIconOutline = forwardRef(function BugAntIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BugAntIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingLibraryIconOutlineOriginal from '@heroicons/react/24/outline/BuildingLibraryIcon';
export const BuildingLibraryIconOutline = forwardRef(function BuildingLibraryIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingLibraryIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingOffice2IconOutlineOriginal from '@heroicons/react/24/outline/BuildingOffice2Icon';
export const BuildingOffice2IconOutline = forwardRef(function BuildingOffice2IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingOffice2IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingOfficeIconOutlineOriginal from '@heroicons/react/24/outline/BuildingOfficeIcon';
export const BuildingOfficeIconOutline = forwardRef(function BuildingOfficeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingOfficeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingStorefrontIconOutlineOriginal from '@heroicons/react/24/outline/BuildingStorefrontIcon';
export const BuildingStorefrontIconOutline = forwardRef(function BuildingStorefrontIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingStorefrontIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CakeIconOutlineOriginal from '@heroicons/react/24/outline/CakeIcon';
export const CakeIconOutline = forwardRef(function CakeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CakeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalculatorIconOutlineOriginal from '@heroicons/react/24/outline/CalculatorIcon';
export const CalculatorIconOutline = forwardRef(function CalculatorIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalculatorIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarDateRangeIconOutlineOriginal from '@heroicons/react/24/outline/CalendarDateRangeIcon';
export const CalendarDateRangeIconOutline = forwardRef(function CalendarDateRangeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarDateRangeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarDaysIconOutlineOriginal from '@heroicons/react/24/outline/CalendarDaysIcon';
export const CalendarDaysIconOutline = forwardRef(function CalendarDaysIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarDaysIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarIconOutlineOriginal from '@heroicons/react/24/outline/CalendarIcon';
export const CalendarIconOutline = forwardRef(function CalendarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CameraIconOutlineOriginal from '@heroicons/react/24/outline/CameraIcon';
export const CameraIconOutline = forwardRef(function CameraIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CameraIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartBarSquareIconOutlineOriginal from '@heroicons/react/24/outline/ChartBarSquareIcon';
export const ChartBarSquareIconOutline = forwardRef(function ChartBarSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartBarSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartBarIconOutlineOriginal from '@heroicons/react/24/outline/ChartBarIcon';
export const ChartBarIconOutline = forwardRef(function ChartBarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartBarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartPieIconOutlineOriginal from '@heroicons/react/24/outline/ChartPieIcon';
export const ChartPieIconOutline = forwardRef(function ChartPieIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartPieIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleBottomCenterTextIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleBottomCenterTextIcon';
export const ChatBubbleBottomCenterTextIconOutline = forwardRef(function ChatBubbleBottomCenterTextIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleBottomCenterTextIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleBottomCenterIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleBottomCenterIcon';
export const ChatBubbleBottomCenterIconOutline = forwardRef(function ChatBubbleBottomCenterIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleBottomCenterIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftEllipsisIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleLeftEllipsisIcon';
export const ChatBubbleLeftEllipsisIconOutline = forwardRef(function ChatBubbleLeftEllipsisIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftEllipsisIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftRightIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleLeftRightIcon';
export const ChatBubbleLeftRightIconOutline = forwardRef(function ChatBubbleLeftRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleLeftIcon';
export const ChatBubbleLeftIconOutline = forwardRef(function ChatBubbleLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleOvalLeftEllipsisIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleOvalLeftEllipsisIcon';
export const ChatBubbleOvalLeftEllipsisIconOutline = forwardRef(function ChatBubbleOvalLeftEllipsisIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleOvalLeftEllipsisIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleOvalLeftIconOutlineOriginal from '@heroicons/react/24/outline/ChatBubbleOvalLeftIcon';
export const ChatBubbleOvalLeftIconOutline = forwardRef(function ChatBubbleOvalLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleOvalLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckBadgeIconOutlineOriginal from '@heroicons/react/24/outline/CheckBadgeIcon';
export const CheckBadgeIconOutline = forwardRef(function CheckBadgeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckBadgeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckCircleIconOutlineOriginal from '@heroicons/react/24/outline/CheckCircleIcon';
export const CheckCircleIconOutline = forwardRef(function CheckCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckIconOutlineOriginal from '@heroicons/react/24/outline/CheckIcon';
export const CheckIconOutline = forwardRef(function CheckIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleDownIconOutlineOriginal from '@heroicons/react/24/outline/ChevronDoubleDownIcon';
export const ChevronDoubleDownIconOutline = forwardRef(function ChevronDoubleDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleLeftIconOutlineOriginal from '@heroicons/react/24/outline/ChevronDoubleLeftIcon';
export const ChevronDoubleLeftIconOutline = forwardRef(function ChevronDoubleLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleRightIconOutlineOriginal from '@heroicons/react/24/outline/ChevronDoubleRightIcon';
export const ChevronDoubleRightIconOutline = forwardRef(function ChevronDoubleRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleUpIconOutlineOriginal from '@heroicons/react/24/outline/ChevronDoubleUpIcon';
export const ChevronDoubleUpIconOutline = forwardRef(function ChevronDoubleUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDownIconOutlineOriginal from '@heroicons/react/24/outline/ChevronDownIcon';
export const ChevronDownIconOutline = forwardRef(function ChevronDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronLeftIconOutlineOriginal from '@heroicons/react/24/outline/ChevronLeftIcon';
export const ChevronLeftIconOutline = forwardRef(function ChevronLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronRightIconOutlineOriginal from '@heroicons/react/24/outline/ChevronRightIcon';
export const ChevronRightIconOutline = forwardRef(function ChevronRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronUpDownIconOutlineOriginal from '@heroicons/react/24/outline/ChevronUpDownIcon';
export const ChevronUpDownIconOutline = forwardRef(function ChevronUpDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronUpDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronUpIconOutlineOriginal from '@heroicons/react/24/outline/ChevronUpIcon';
export const ChevronUpIconOutline = forwardRef(function ChevronUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CircleStackIconOutlineOriginal from '@heroicons/react/24/outline/CircleStackIcon';
export const CircleStackIconOutline = forwardRef(function CircleStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CircleStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentCheckIconOutlineOriginal from '@heroicons/react/24/outline/ClipboardDocumentCheckIcon';
export const ClipboardDocumentCheckIconOutline = forwardRef(function ClipboardDocumentCheckIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentCheckIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentListIconOutlineOriginal from '@heroicons/react/24/outline/ClipboardDocumentListIcon';
export const ClipboardDocumentListIconOutline = forwardRef(function ClipboardDocumentListIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentListIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentIconOutlineOriginal from '@heroicons/react/24/outline/ClipboardDocumentIcon';
export const ClipboardDocumentIconOutline = forwardRef(function ClipboardDocumentIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardIconOutlineOriginal from '@heroicons/react/24/outline/ClipboardIcon';
export const ClipboardIconOutline = forwardRef(function ClipboardIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClockIconOutlineOriginal from '@heroicons/react/24/outline/ClockIcon';
export const ClockIconOutline = forwardRef(function ClockIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClockIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/CloudArrowDownIcon';
export const CloudArrowDownIconOutline = forwardRef(function CloudArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudArrowUpIconOutlineOriginal from '@heroicons/react/24/outline/CloudArrowUpIcon';
export const CloudArrowUpIconOutline = forwardRef(function CloudArrowUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudArrowUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudIconOutlineOriginal from '@heroicons/react/24/outline/CloudIcon';
export const CloudIconOutline = forwardRef(function CloudIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CodeBracketSquareIconOutlineOriginal from '@heroicons/react/24/outline/CodeBracketSquareIcon';
export const CodeBracketSquareIconOutline = forwardRef(function CodeBracketSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CodeBracketSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CodeBracketIconOutlineOriginal from '@heroicons/react/24/outline/CodeBracketIcon';
export const CodeBracketIconOutline = forwardRef(function CodeBracketIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CodeBracketIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Cog6ToothIconOutlineOriginal from '@heroicons/react/24/outline/Cog6ToothIcon';
export const Cog6ToothIconOutline = forwardRef(function Cog6ToothIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Cog6ToothIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Cog8ToothIconOutlineOriginal from '@heroicons/react/24/outline/Cog8ToothIcon';
export const Cog8ToothIconOutline = forwardRef(function Cog8ToothIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Cog8ToothIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CogIconOutlineOriginal from '@heroicons/react/24/outline/CogIcon';
export const CogIconOutline = forwardRef(function CogIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CogIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CommandLineIconOutlineOriginal from '@heroicons/react/24/outline/CommandLineIcon';
export const CommandLineIconOutline = forwardRef(function CommandLineIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CommandLineIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ComputerDesktopIconOutlineOriginal from '@heroicons/react/24/outline/ComputerDesktopIcon';
export const ComputerDesktopIconOutline = forwardRef(function ComputerDesktopIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ComputerDesktopIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CpuChipIconOutlineOriginal from '@heroicons/react/24/outline/CpuChipIcon';
export const CpuChipIconOutline = forwardRef(function CpuChipIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CpuChipIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CreditCardIconOutlineOriginal from '@heroicons/react/24/outline/CreditCardIcon';
export const CreditCardIconOutline = forwardRef(function CreditCardIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CreditCardIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CubeTransparentIconOutlineOriginal from '@heroicons/react/24/outline/CubeTransparentIcon';
export const CubeTransparentIconOutline = forwardRef(function CubeTransparentIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CubeTransparentIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CubeIconOutlineOriginal from '@heroicons/react/24/outline/CubeIcon';
export const CubeIconOutline = forwardRef(function CubeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CubeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyBangladeshiIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyBangladeshiIcon';
export const CurrencyBangladeshiIconOutline = forwardRef(function CurrencyBangladeshiIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyBangladeshiIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyDollarIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyDollarIcon';
export const CurrencyDollarIconOutline = forwardRef(function CurrencyDollarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyDollarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyEuroIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyEuroIcon';
export const CurrencyEuroIconOutline = forwardRef(function CurrencyEuroIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyEuroIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyPoundIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyPoundIcon';
export const CurrencyPoundIconOutline = forwardRef(function CurrencyPoundIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyPoundIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyRupeeIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyRupeeIcon';
export const CurrencyRupeeIconOutline = forwardRef(function CurrencyRupeeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyRupeeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyYenIconOutlineOriginal from '@heroicons/react/24/outline/CurrencyYenIcon';
export const CurrencyYenIconOutline = forwardRef(function CurrencyYenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyYenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CursorArrowRaysIconOutlineOriginal from '@heroicons/react/24/outline/CursorArrowRaysIcon';
export const CursorArrowRaysIconOutline = forwardRef(function CursorArrowRaysIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CursorArrowRaysIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CursorArrowRippleIconOutlineOriginal from '@heroicons/react/24/outline/CursorArrowRippleIcon';
export const CursorArrowRippleIconOutline = forwardRef(function CursorArrowRippleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CursorArrowRippleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DevicePhoneMobileIconOutlineOriginal from '@heroicons/react/24/outline/DevicePhoneMobileIcon';
export const DevicePhoneMobileIconOutline = forwardRef(function DevicePhoneMobileIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DevicePhoneMobileIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DeviceTabletIconOutlineOriginal from '@heroicons/react/24/outline/DeviceTabletIcon';
export const DeviceTabletIconOutline = forwardRef(function DeviceTabletIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DeviceTabletIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DivideIconOutlineOriginal from '@heroicons/react/24/outline/DivideIcon';
export const DivideIconOutline = forwardRef(function DivideIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DivideIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/DocumentArrowDownIcon';
export const DocumentArrowDownIconOutline = forwardRef(function DocumentArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentArrowUpIconOutlineOriginal from '@heroicons/react/24/outline/DocumentArrowUpIcon';
export const DocumentArrowUpIconOutline = forwardRef(function DocumentArrowUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentArrowUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentChartBarIconOutlineOriginal from '@heroicons/react/24/outline/DocumentChartBarIcon';
export const DocumentChartBarIconOutline = forwardRef(function DocumentChartBarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentChartBarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCheckIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCheckIcon';
export const DocumentCheckIconOutline = forwardRef(function DocumentCheckIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCheckIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyBangladeshiIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyBangladeshiIcon';
export const DocumentCurrencyBangladeshiIconOutline = forwardRef(function DocumentCurrencyBangladeshiIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyBangladeshiIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyDollarIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyDollarIcon';
export const DocumentCurrencyDollarIconOutline = forwardRef(function DocumentCurrencyDollarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyDollarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyEuroIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyEuroIcon';
export const DocumentCurrencyEuroIconOutline = forwardRef(function DocumentCurrencyEuroIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyEuroIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyPoundIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyPoundIcon';
export const DocumentCurrencyPoundIconOutline = forwardRef(function DocumentCurrencyPoundIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyPoundIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyRupeeIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyRupeeIcon';
export const DocumentCurrencyRupeeIconOutline = forwardRef(function DocumentCurrencyRupeeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyRupeeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyYenIconOutlineOriginal from '@heroicons/react/24/outline/DocumentCurrencyYenIcon';
export const DocumentCurrencyYenIconOutline = forwardRef(function DocumentCurrencyYenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyYenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentDuplicateIconOutlineOriginal from '@heroicons/react/24/outline/DocumentDuplicateIcon';
export const DocumentDuplicateIconOutline = forwardRef(function DocumentDuplicateIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentDuplicateIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentMagnifyingGlassIconOutlineOriginal from '@heroicons/react/24/outline/DocumentMagnifyingGlassIcon';
export const DocumentMagnifyingGlassIconOutline = forwardRef(function DocumentMagnifyingGlassIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentMagnifyingGlassIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentMinusIconOutlineOriginal from '@heroicons/react/24/outline/DocumentMinusIcon';
export const DocumentMinusIconOutline = forwardRef(function DocumentMinusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentMinusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentPlusIconOutlineOriginal from '@heroicons/react/24/outline/DocumentPlusIcon';
export const DocumentPlusIconOutline = forwardRef(function DocumentPlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentPlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentTextIconOutlineOriginal from '@heroicons/react/24/outline/DocumentTextIcon';
export const DocumentTextIconOutline = forwardRef(function DocumentTextIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentTextIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentIconOutlineOriginal from '@heroicons/react/24/outline/DocumentIcon';
export const DocumentIconOutline = forwardRef(function DocumentIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisHorizontalCircleIconOutlineOriginal from '@heroicons/react/24/outline/EllipsisHorizontalCircleIcon';
export const EllipsisHorizontalCircleIconOutline = forwardRef(function EllipsisHorizontalCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisHorizontalCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisHorizontalIconOutlineOriginal from '@heroicons/react/24/outline/EllipsisHorizontalIcon';
export const EllipsisHorizontalIconOutline = forwardRef(function EllipsisHorizontalIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisHorizontalIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisVerticalIconOutlineOriginal from '@heroicons/react/24/outline/EllipsisVerticalIcon';
export const EllipsisVerticalIconOutline = forwardRef(function EllipsisVerticalIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisVerticalIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EnvelopeOpenIconOutlineOriginal from '@heroicons/react/24/outline/EnvelopeOpenIcon';
export const EnvelopeOpenIconOutline = forwardRef(function EnvelopeOpenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EnvelopeOpenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EnvelopeIconOutlineOriginal from '@heroicons/react/24/outline/EnvelopeIcon';
export const EnvelopeIconOutline = forwardRef(function EnvelopeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EnvelopeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EqualsIconOutlineOriginal from '@heroicons/react/24/outline/EqualsIcon';
export const EqualsIconOutline = forwardRef(function EqualsIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EqualsIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ExclamationCircleIconOutlineOriginal from '@heroicons/react/24/outline/ExclamationCircleIcon';
export const ExclamationCircleIconOutline = forwardRef(function ExclamationCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ExclamationCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ExclamationTriangleIconOutlineOriginal from '@heroicons/react/24/outline/ExclamationTriangleIcon';
export const ExclamationTriangleIconOutline = forwardRef(function ExclamationTriangleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ExclamationTriangleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeDropperIconOutlineOriginal from '@heroicons/react/24/outline/EyeDropperIcon';
export const EyeDropperIconOutline = forwardRef(function EyeDropperIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeDropperIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeSlashIconOutlineOriginal from '@heroicons/react/24/outline/EyeSlashIcon';
export const EyeSlashIconOutline = forwardRef(function EyeSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeIconOutlineOriginal from '@heroicons/react/24/outline/EyeIcon';
export const EyeIconOutline = forwardRef(function EyeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FaceFrownIconOutlineOriginal from '@heroicons/react/24/outline/FaceFrownIcon';
export const FaceFrownIconOutline = forwardRef(function FaceFrownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FaceFrownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FaceSmileIconOutlineOriginal from '@heroicons/react/24/outline/FaceSmileIcon';
export const FaceSmileIconOutline = forwardRef(function FaceSmileIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FaceSmileIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FilmIconOutlineOriginal from '@heroicons/react/24/outline/FilmIcon';
export const FilmIconOutline = forwardRef(function FilmIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FilmIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FingerPrintIconOutlineOriginal from '@heroicons/react/24/outline/FingerPrintIcon';
export const FingerPrintIconOutline = forwardRef(function FingerPrintIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FingerPrintIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FireIconOutlineOriginal from '@heroicons/react/24/outline/FireIcon';
export const FireIconOutline = forwardRef(function FireIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FireIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FlagIconOutlineOriginal from '@heroicons/react/24/outline/FlagIcon';
export const FlagIconOutline = forwardRef(function FlagIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FlagIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/FolderArrowDownIcon';
export const FolderArrowDownIconOutline = forwardRef(function FolderArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderMinusIconOutlineOriginal from '@heroicons/react/24/outline/FolderMinusIcon';
export const FolderMinusIconOutline = forwardRef(function FolderMinusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderMinusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderOpenIconOutlineOriginal from '@heroicons/react/24/outline/FolderOpenIcon';
export const FolderOpenIconOutline = forwardRef(function FolderOpenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderOpenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderPlusIconOutlineOriginal from '@heroicons/react/24/outline/FolderPlusIcon';
export const FolderPlusIconOutline = forwardRef(function FolderPlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderPlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderIconOutlineOriginal from '@heroicons/react/24/outline/FolderIcon';
export const FolderIconOutline = forwardRef(function FolderIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ForwardIconOutlineOriginal from '@heroicons/react/24/outline/ForwardIcon';
export const ForwardIconOutline = forwardRef(function ForwardIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ForwardIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FunnelIconOutlineOriginal from '@heroicons/react/24/outline/FunnelIcon';
export const FunnelIconOutline = forwardRef(function FunnelIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FunnelIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GifIconOutlineOriginal from '@heroicons/react/24/outline/GifIcon';
export const GifIconOutline = forwardRef(function GifIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GifIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GiftTopIconOutlineOriginal from '@heroicons/react/24/outline/GiftTopIcon';
export const GiftTopIconOutline = forwardRef(function GiftTopIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GiftTopIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GiftIconOutlineOriginal from '@heroicons/react/24/outline/GiftIcon';
export const GiftIconOutline = forwardRef(function GiftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GiftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAltIconOutlineOriginal from '@heroicons/react/24/outline/GlobeAltIcon';
export const GlobeAltIconOutline = forwardRef(function GlobeAltIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAltIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAmericasIconOutlineOriginal from '@heroicons/react/24/outline/GlobeAmericasIcon';
export const GlobeAmericasIconOutline = forwardRef(function GlobeAmericasIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAmericasIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAsiaAustraliaIconOutlineOriginal from '@heroicons/react/24/outline/GlobeAsiaAustraliaIcon';
export const GlobeAsiaAustraliaIconOutline = forwardRef(function GlobeAsiaAustraliaIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAsiaAustraliaIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeEuropeAfricaIconOutlineOriginal from '@heroicons/react/24/outline/GlobeEuropeAfricaIcon';
export const GlobeEuropeAfricaIconOutline = forwardRef(function GlobeEuropeAfricaIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeEuropeAfricaIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H1IconOutlineOriginal from '@heroicons/react/24/outline/H1Icon';
export const H1IconOutline = forwardRef(function H1IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H1IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H2IconOutlineOriginal from '@heroicons/react/24/outline/H2Icon';
export const H2IconOutline = forwardRef(function H2IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H2IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H3IconOutlineOriginal from '@heroicons/react/24/outline/H3Icon';
export const H3IconOutline = forwardRef(function H3IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H3IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandRaisedIconOutlineOriginal from '@heroicons/react/24/outline/HandRaisedIcon';
export const HandRaisedIconOutline = forwardRef(function HandRaisedIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandRaisedIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandThumbDownIconOutlineOriginal from '@heroicons/react/24/outline/HandThumbDownIcon';
export const HandThumbDownIconOutline = forwardRef(function HandThumbDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandThumbDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandThumbUpIconOutlineOriginal from '@heroicons/react/24/outline/HandThumbUpIcon';
export const HandThumbUpIconOutline = forwardRef(function HandThumbUpIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandThumbUpIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HashtagIconOutlineOriginal from '@heroicons/react/24/outline/HashtagIcon';
export const HashtagIconOutline = forwardRef(function HashtagIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HashtagIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HeartIconOutlineOriginal from '@heroicons/react/24/outline/HeartIcon';
export const HeartIconOutline = forwardRef(function HeartIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HeartIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HomeModernIconOutlineOriginal from '@heroicons/react/24/outline/HomeModernIcon';
export const HomeModernIconOutline = forwardRef(function HomeModernIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HomeModernIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HomeIconOutlineOriginal from '@heroicons/react/24/outline/HomeIcon';
export const HomeIconOutline = forwardRef(function HomeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HomeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import IdentificationIconOutlineOriginal from '@heroicons/react/24/outline/IdentificationIcon';
export const IdentificationIconOutline = forwardRef(function IdentificationIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(IdentificationIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxArrowDownIconOutlineOriginal from '@heroicons/react/24/outline/InboxArrowDownIcon';
export const InboxArrowDownIconOutline = forwardRef(function InboxArrowDownIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxArrowDownIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxStackIconOutlineOriginal from '@heroicons/react/24/outline/InboxStackIcon';
export const InboxStackIconOutline = forwardRef(function InboxStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxIconOutlineOriginal from '@heroicons/react/24/outline/InboxIcon';
export const InboxIconOutline = forwardRef(function InboxIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InformationCircleIconOutlineOriginal from '@heroicons/react/24/outline/InformationCircleIcon';
export const InformationCircleIconOutline = forwardRef(function InformationCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InformationCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ItalicIconOutlineOriginal from '@heroicons/react/24/outline/ItalicIcon';
export const ItalicIconOutline = forwardRef(function ItalicIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ItalicIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import KeyIconOutlineOriginal from '@heroicons/react/24/outline/KeyIcon';
export const KeyIconOutline = forwardRef(function KeyIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(KeyIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LanguageIconOutlineOriginal from '@heroicons/react/24/outline/LanguageIcon';
export const LanguageIconOutline = forwardRef(function LanguageIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LanguageIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LifebuoyIconOutlineOriginal from '@heroicons/react/24/outline/LifebuoyIcon';
export const LifebuoyIconOutline = forwardRef(function LifebuoyIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LifebuoyIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LightBulbIconOutlineOriginal from '@heroicons/react/24/outline/LightBulbIcon';
export const LightBulbIconOutline = forwardRef(function LightBulbIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LightBulbIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LinkSlashIconOutlineOriginal from '@heroicons/react/24/outline/LinkSlashIcon';
export const LinkSlashIconOutline = forwardRef(function LinkSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LinkSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LinkIconOutlineOriginal from '@heroicons/react/24/outline/LinkIcon';
export const LinkIconOutline = forwardRef(function LinkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LinkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ListBulletIconOutlineOriginal from '@heroicons/react/24/outline/ListBulletIcon';
export const ListBulletIconOutline = forwardRef(function ListBulletIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ListBulletIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LockClosedIconOutlineOriginal from '@heroicons/react/24/outline/LockClosedIcon';
export const LockClosedIconOutline = forwardRef(function LockClosedIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LockClosedIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LockOpenIconOutlineOriginal from '@heroicons/react/24/outline/LockOpenIcon';
export const LockOpenIconOutline = forwardRef(function LockOpenIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LockOpenIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassCircleIconOutlineOriginal from '@heroicons/react/24/outline/MagnifyingGlassCircleIcon';
export const MagnifyingGlassCircleIconOutline = forwardRef(function MagnifyingGlassCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassMinusIconOutlineOriginal from '@heroicons/react/24/outline/MagnifyingGlassMinusIcon';
export const MagnifyingGlassMinusIconOutline = forwardRef(function MagnifyingGlassMinusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassMinusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassPlusIconOutlineOriginal from '@heroicons/react/24/outline/MagnifyingGlassPlusIcon';
export const MagnifyingGlassPlusIconOutline = forwardRef(function MagnifyingGlassPlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassPlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassIconOutlineOriginal from '@heroicons/react/24/outline/MagnifyingGlassIcon';
export const MagnifyingGlassIconOutline = forwardRef(function MagnifyingGlassIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MapPinIconOutlineOriginal from '@heroicons/react/24/outline/MapPinIcon';
export const MapPinIconOutline = forwardRef(function MapPinIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MapPinIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MapIconOutlineOriginal from '@heroicons/react/24/outline/MapIcon';
export const MapIconOutline = forwardRef(function MapIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MapIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MegaphoneIconOutlineOriginal from '@heroicons/react/24/outline/MegaphoneIcon';
export const MegaphoneIconOutline = forwardRef(function MegaphoneIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MegaphoneIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MicrophoneIconOutlineOriginal from '@heroicons/react/24/outline/MicrophoneIcon';
export const MicrophoneIconOutline = forwardRef(function MicrophoneIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MicrophoneIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusCircleIconOutlineOriginal from '@heroicons/react/24/outline/MinusCircleIcon';
export const MinusCircleIconOutline = forwardRef(function MinusCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusSmallIconOutlineOriginal from '@heroicons/react/24/outline/MinusSmallIcon';
export const MinusSmallIconOutline = forwardRef(function MinusSmallIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusSmallIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusIconOutlineOriginal from '@heroicons/react/24/outline/MinusIcon';
export const MinusIconOutline = forwardRef(function MinusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MoonIconOutlineOriginal from '@heroicons/react/24/outline/MoonIcon';
export const MoonIconOutline = forwardRef(function MoonIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MoonIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MusicalNoteIconOutlineOriginal from '@heroicons/react/24/outline/MusicalNoteIcon';
export const MusicalNoteIconOutline = forwardRef(function MusicalNoteIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MusicalNoteIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NewspaperIconOutlineOriginal from '@heroicons/react/24/outline/NewspaperIcon';
export const NewspaperIconOutline = forwardRef(function NewspaperIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NewspaperIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NoSymbolIconOutlineOriginal from '@heroicons/react/24/outline/NoSymbolIcon';
export const NoSymbolIconOutline = forwardRef(function NoSymbolIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NoSymbolIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NumberedListIconOutlineOriginal from '@heroicons/react/24/outline/NumberedListIcon';
export const NumberedListIconOutline = forwardRef(function NumberedListIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NumberedListIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaintBrushIconOutlineOriginal from '@heroicons/react/24/outline/PaintBrushIcon';
export const PaintBrushIconOutline = forwardRef(function PaintBrushIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaintBrushIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaperAirplaneIconOutlineOriginal from '@heroicons/react/24/outline/PaperAirplaneIcon';
export const PaperAirplaneIconOutline = forwardRef(function PaperAirplaneIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaperAirplaneIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaperClipIconOutlineOriginal from '@heroicons/react/24/outline/PaperClipIcon';
export const PaperClipIconOutline = forwardRef(function PaperClipIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaperClipIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PauseCircleIconOutlineOriginal from '@heroicons/react/24/outline/PauseCircleIcon';
export const PauseCircleIconOutline = forwardRef(function PauseCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PauseCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PauseIconOutlineOriginal from '@heroicons/react/24/outline/PauseIcon';
export const PauseIconOutline = forwardRef(function PauseIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PauseIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PencilSquareIconOutlineOriginal from '@heroicons/react/24/outline/PencilSquareIcon';
export const PencilSquareIconOutline = forwardRef(function PencilSquareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PencilSquareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PencilIconOutlineOriginal from '@heroicons/react/24/outline/PencilIcon';
export const PencilIconOutline = forwardRef(function PencilIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PencilIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PercentBadgeIconOutlineOriginal from '@heroicons/react/24/outline/PercentBadgeIcon';
export const PercentBadgeIconOutline = forwardRef(function PercentBadgeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PercentBadgeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneArrowDownLeftIconOutlineOriginal from '@heroicons/react/24/outline/PhoneArrowDownLeftIcon';
export const PhoneArrowDownLeftIconOutline = forwardRef(function PhoneArrowDownLeftIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneArrowDownLeftIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneArrowUpRightIconOutlineOriginal from '@heroicons/react/24/outline/PhoneArrowUpRightIcon';
export const PhoneArrowUpRightIconOutline = forwardRef(function PhoneArrowUpRightIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneArrowUpRightIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneXMarkIconOutlineOriginal from '@heroicons/react/24/outline/PhoneXMarkIcon';
export const PhoneXMarkIconOutline = forwardRef(function PhoneXMarkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneXMarkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneIconOutlineOriginal from '@heroicons/react/24/outline/PhoneIcon';
export const PhoneIconOutline = forwardRef(function PhoneIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhotoIconOutlineOriginal from '@heroicons/react/24/outline/PhotoIcon';
export const PhotoIconOutline = forwardRef(function PhotoIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhotoIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayCircleIconOutlineOriginal from '@heroicons/react/24/outline/PlayCircleIcon';
export const PlayCircleIconOutline = forwardRef(function PlayCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayPauseIconOutlineOriginal from '@heroicons/react/24/outline/PlayPauseIcon';
export const PlayPauseIconOutline = forwardRef(function PlayPauseIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayPauseIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayIconOutlineOriginal from '@heroicons/react/24/outline/PlayIcon';
export const PlayIconOutline = forwardRef(function PlayIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusCircleIconOutlineOriginal from '@heroicons/react/24/outline/PlusCircleIcon';
export const PlusCircleIconOutline = forwardRef(function PlusCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusSmallIconOutlineOriginal from '@heroicons/react/24/outline/PlusSmallIcon';
export const PlusSmallIconOutline = forwardRef(function PlusSmallIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusSmallIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusIconOutlineOriginal from '@heroicons/react/24/outline/PlusIcon';
export const PlusIconOutline = forwardRef(function PlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PowerIconOutlineOriginal from '@heroicons/react/24/outline/PowerIcon';
export const PowerIconOutline = forwardRef(function PowerIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PowerIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PresentationChartBarIconOutlineOriginal from '@heroicons/react/24/outline/PresentationChartBarIcon';
export const PresentationChartBarIconOutline = forwardRef(function PresentationChartBarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PresentationChartBarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PresentationChartLineIconOutlineOriginal from '@heroicons/react/24/outline/PresentationChartLineIcon';
export const PresentationChartLineIconOutline = forwardRef(function PresentationChartLineIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PresentationChartLineIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PrinterIconOutlineOriginal from '@heroicons/react/24/outline/PrinterIcon';
export const PrinterIconOutline = forwardRef(function PrinterIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PrinterIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PuzzlePieceIconOutlineOriginal from '@heroicons/react/24/outline/PuzzlePieceIcon';
export const PuzzlePieceIconOutline = forwardRef(function PuzzlePieceIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PuzzlePieceIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QrCodeIconOutlineOriginal from '@heroicons/react/24/outline/QrCodeIcon';
export const QrCodeIconOutline = forwardRef(function QrCodeIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QrCodeIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QuestionMarkCircleIconOutlineOriginal from '@heroicons/react/24/outline/QuestionMarkCircleIcon';
export const QuestionMarkCircleIconOutline = forwardRef(function QuestionMarkCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QuestionMarkCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QueueListIconOutlineOriginal from '@heroicons/react/24/outline/QueueListIcon';
export const QueueListIconOutline = forwardRef(function QueueListIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QueueListIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RadioIconOutlineOriginal from '@heroicons/react/24/outline/RadioIcon';
export const RadioIconOutline = forwardRef(function RadioIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RadioIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ReceiptPercentIconOutlineOriginal from '@heroicons/react/24/outline/ReceiptPercentIcon';
export const ReceiptPercentIconOutline = forwardRef(function ReceiptPercentIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ReceiptPercentIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ReceiptRefundIconOutlineOriginal from '@heroicons/react/24/outline/ReceiptRefundIcon';
export const ReceiptRefundIconOutline = forwardRef(function ReceiptRefundIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ReceiptRefundIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RectangleGroupIconOutlineOriginal from '@heroicons/react/24/outline/RectangleGroupIcon';
export const RectangleGroupIconOutline = forwardRef(function RectangleGroupIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RectangleGroupIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RectangleStackIconOutlineOriginal from '@heroicons/react/24/outline/RectangleStackIcon';
export const RectangleStackIconOutline = forwardRef(function RectangleStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RectangleStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RocketLaunchIconOutlineOriginal from '@heroicons/react/24/outline/RocketLaunchIcon';
export const RocketLaunchIconOutline = forwardRef(function RocketLaunchIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RocketLaunchIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RssIconOutlineOriginal from '@heroicons/react/24/outline/RssIcon';
export const RssIconOutline = forwardRef(function RssIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RssIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ScaleIconOutlineOriginal from '@heroicons/react/24/outline/ScaleIcon';
export const ScaleIconOutline = forwardRef(function ScaleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ScaleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ScissorsIconOutlineOriginal from '@heroicons/react/24/outline/ScissorsIcon';
export const ScissorsIconOutline = forwardRef(function ScissorsIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ScissorsIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ServerStackIconOutlineOriginal from '@heroicons/react/24/outline/ServerStackIcon';
export const ServerStackIconOutline = forwardRef(function ServerStackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ServerStackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ServerIconOutlineOriginal from '@heroicons/react/24/outline/ServerIcon';
export const ServerIconOutline = forwardRef(function ServerIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ServerIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShareIconOutlineOriginal from '@heroicons/react/24/outline/ShareIcon';
export const ShareIconOutline = forwardRef(function ShareIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShareIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShieldCheckIconOutlineOriginal from '@heroicons/react/24/outline/ShieldCheckIcon';
export const ShieldCheckIconOutline = forwardRef(function ShieldCheckIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShieldCheckIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShieldExclamationIconOutlineOriginal from '@heroicons/react/24/outline/ShieldExclamationIcon';
export const ShieldExclamationIconOutline = forwardRef(function ShieldExclamationIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShieldExclamationIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShoppingBagIconOutlineOriginal from '@heroicons/react/24/outline/ShoppingBagIcon';
export const ShoppingBagIconOutline = forwardRef(function ShoppingBagIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShoppingBagIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShoppingCartIconOutlineOriginal from '@heroicons/react/24/outline/ShoppingCartIcon';
export const ShoppingCartIconOutline = forwardRef(function ShoppingCartIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShoppingCartIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SignalSlashIconOutlineOriginal from '@heroicons/react/24/outline/SignalSlashIcon';
export const SignalSlashIconOutline = forwardRef(function SignalSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SignalSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SignalIconOutlineOriginal from '@heroicons/react/24/outline/SignalIcon';
export const SignalIconOutline = forwardRef(function SignalIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SignalIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SlashIconOutlineOriginal from '@heroicons/react/24/outline/SlashIcon';
export const SlashIconOutline = forwardRef(function SlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SparklesIconOutlineOriginal from '@heroicons/react/24/outline/SparklesIcon';
export const SparklesIconOutline = forwardRef(function SparklesIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SparklesIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SpeakerWaveIconOutlineOriginal from '@heroicons/react/24/outline/SpeakerWaveIcon';
export const SpeakerWaveIconOutline = forwardRef(function SpeakerWaveIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SpeakerWaveIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SpeakerXMarkIconOutlineOriginal from '@heroicons/react/24/outline/SpeakerXMarkIcon';
export const SpeakerXMarkIconOutline = forwardRef(function SpeakerXMarkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SpeakerXMarkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Square2StackIconOutlineOriginal from '@heroicons/react/24/outline/Square2StackIcon';
export const Square2StackIconOutline = forwardRef(function Square2StackIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Square2StackIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Square3Stack3DIconOutlineOriginal from '@heroicons/react/24/outline/Square3Stack3DIcon';
export const Square3Stack3DIconOutline = forwardRef(function Square3Stack3DIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Square3Stack3DIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Squares2X2IconOutlineOriginal from '@heroicons/react/24/outline/Squares2X2Icon';
export const Squares2X2IconOutline = forwardRef(function Squares2X2IconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Squares2X2IconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SquaresPlusIconOutlineOriginal from '@heroicons/react/24/outline/SquaresPlusIcon';
export const SquaresPlusIconOutline = forwardRef(function SquaresPlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SquaresPlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StarIconOutlineOriginal from '@heroicons/react/24/outline/StarIcon';
export const StarIconOutline = forwardRef(function StarIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StarIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StopCircleIconOutlineOriginal from '@heroicons/react/24/outline/StopCircleIcon';
export const StopCircleIconOutline = forwardRef(function StopCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StopCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StopIconOutlineOriginal from '@heroicons/react/24/outline/StopIcon';
export const StopIconOutline = forwardRef(function StopIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StopIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StrikethroughIconOutlineOriginal from '@heroicons/react/24/outline/StrikethroughIcon';
export const StrikethroughIconOutline = forwardRef(function StrikethroughIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StrikethroughIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SunIconOutlineOriginal from '@heroicons/react/24/outline/SunIcon';
export const SunIconOutline = forwardRef(function SunIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SunIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SwatchIconOutlineOriginal from '@heroicons/react/24/outline/SwatchIcon';
export const SwatchIconOutline = forwardRef(function SwatchIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SwatchIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TableCellsIconOutlineOriginal from '@heroicons/react/24/outline/TableCellsIcon';
export const TableCellsIconOutline = forwardRef(function TableCellsIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TableCellsIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TagIconOutlineOriginal from '@heroicons/react/24/outline/TagIcon';
export const TagIconOutline = forwardRef(function TagIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TagIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TicketIconOutlineOriginal from '@heroicons/react/24/outline/TicketIcon';
export const TicketIconOutline = forwardRef(function TicketIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TicketIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TrashIconOutlineOriginal from '@heroicons/react/24/outline/TrashIcon';
export const TrashIconOutline = forwardRef(function TrashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TrashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TrophyIconOutlineOriginal from '@heroicons/react/24/outline/TrophyIcon';
export const TrophyIconOutline = forwardRef(function TrophyIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TrophyIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TruckIconOutlineOriginal from '@heroicons/react/24/outline/TruckIcon';
export const TruckIconOutline = forwardRef(function TruckIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TruckIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TvIconOutlineOriginal from '@heroicons/react/24/outline/TvIcon';
export const TvIconOutline = forwardRef(function TvIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TvIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UnderlineIconOutlineOriginal from '@heroicons/react/24/outline/UnderlineIcon';
export const UnderlineIconOutline = forwardRef(function UnderlineIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UnderlineIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserCircleIconOutlineOriginal from '@heroicons/react/24/outline/UserCircleIcon';
export const UserCircleIconOutline = forwardRef(function UserCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserGroupIconOutlineOriginal from '@heroicons/react/24/outline/UserGroupIcon';
export const UserGroupIconOutline = forwardRef(function UserGroupIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserGroupIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserMinusIconOutlineOriginal from '@heroicons/react/24/outline/UserMinusIcon';
export const UserMinusIconOutline = forwardRef(function UserMinusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserMinusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserPlusIconOutlineOriginal from '@heroicons/react/24/outline/UserPlusIcon';
export const UserPlusIconOutline = forwardRef(function UserPlusIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserPlusIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserIconOutlineOriginal from '@heroicons/react/24/outline/UserIcon';
export const UserIconOutline = forwardRef(function UserIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UsersIconOutlineOriginal from '@heroicons/react/24/outline/UsersIcon';
export const UsersIconOutline = forwardRef(function UsersIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UsersIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VariableIconOutlineOriginal from '@heroicons/react/24/outline/VariableIcon';
export const VariableIconOutline = forwardRef(function VariableIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VariableIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VideoCameraSlashIconOutlineOriginal from '@heroicons/react/24/outline/VideoCameraSlashIcon';
export const VideoCameraSlashIconOutline = forwardRef(function VideoCameraSlashIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VideoCameraSlashIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VideoCameraIconOutlineOriginal from '@heroicons/react/24/outline/VideoCameraIcon';
export const VideoCameraIconOutline = forwardRef(function VideoCameraIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VideoCameraIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ViewColumnsIconOutlineOriginal from '@heroicons/react/24/outline/ViewColumnsIcon';
export const ViewColumnsIconOutline = forwardRef(function ViewColumnsIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ViewColumnsIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ViewfinderCircleIconOutlineOriginal from '@heroicons/react/24/outline/ViewfinderCircleIcon';
export const ViewfinderCircleIconOutline = forwardRef(function ViewfinderCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ViewfinderCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WalletIconOutlineOriginal from '@heroicons/react/24/outline/WalletIcon';
export const WalletIconOutline = forwardRef(function WalletIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WalletIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WifiIconOutlineOriginal from '@heroicons/react/24/outline/WifiIcon';
export const WifiIconOutline = forwardRef(function WifiIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WifiIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WindowIconOutlineOriginal from '@heroicons/react/24/outline/WindowIcon';
export const WindowIconOutline = forwardRef(function WindowIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WindowIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WrenchScrewdriverIconOutlineOriginal from '@heroicons/react/24/outline/WrenchScrewdriverIcon';
export const WrenchScrewdriverIconOutline = forwardRef(function WrenchScrewdriverIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WrenchScrewdriverIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WrenchIconOutlineOriginal from '@heroicons/react/24/outline/WrenchIcon';
export const WrenchIconOutline = forwardRef(function WrenchIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WrenchIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import XCircleIconOutlineOriginal from '@heroicons/react/24/outline/XCircleIcon';
export const XCircleIconOutline = forwardRef(function XCircleIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(XCircleIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import XMarkIconOutlineOriginal from '@heroicons/react/24/outline/XMarkIcon';
export const XMarkIconOutline = forwardRef(function XMarkIconOutline(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(XMarkIconOutlineOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AcademicCapIconSolidOriginal from '@heroicons/react/24/solid/AcademicCapIcon';
export const AcademicCapIconSolid = forwardRef(function AcademicCapIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AcademicCapIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AdjustmentsHorizontalIconSolidOriginal from '@heroicons/react/24/solid/AdjustmentsHorizontalIcon';
export const AdjustmentsHorizontalIconSolid = forwardRef(function AdjustmentsHorizontalIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AdjustmentsHorizontalIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AdjustmentsVerticalIconSolidOriginal from '@heroicons/react/24/solid/AdjustmentsVerticalIcon';
export const AdjustmentsVerticalIconSolid = forwardRef(function AdjustmentsVerticalIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AdjustmentsVerticalIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxArrowDownIconSolidOriginal from '@heroicons/react/24/solid/ArchiveBoxArrowDownIcon';
export const ArchiveBoxArrowDownIconSolid = forwardRef(function ArchiveBoxArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxXMarkIconSolidOriginal from '@heroicons/react/24/solid/ArchiveBoxXMarkIcon';
export const ArchiveBoxXMarkIconSolid = forwardRef(function ArchiveBoxXMarkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxXMarkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArchiveBoxIconSolidOriginal from '@heroicons/react/24/solid/ArchiveBoxIcon';
export const ArchiveBoxIconSolid = forwardRef(function ArchiveBoxIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArchiveBoxIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownCircleIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownCircleIcon';
export const ArrowDownCircleIconSolid = forwardRef(function ArrowDownCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownLeftIcon';
export const ArrowDownLeftIconSolid = forwardRef(function ArrowDownLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownOnSquareStackIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownOnSquareStackIcon';
export const ArrowDownOnSquareStackIconSolid = forwardRef(function ArrowDownOnSquareStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownOnSquareStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownOnSquareIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownOnSquareIcon';
export const ArrowDownOnSquareIconSolid = forwardRef(function ArrowDownOnSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownOnSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownRightIcon';
export const ArrowDownRightIconSolid = forwardRef(function ArrowDownRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownTrayIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownTrayIcon';
export const ArrowDownTrayIconSolid = forwardRef(function ArrowDownTrayIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownTrayIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowDownIcon';
export const ArrowDownIconSolid = forwardRef(function ArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftCircleIconSolidOriginal from '@heroicons/react/24/solid/ArrowLeftCircleIcon';
export const ArrowLeftCircleIconSolid = forwardRef(function ArrowLeftCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftEndOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowLeftEndOnRectangleIcon';
export const ArrowLeftEndOnRectangleIconSolid = forwardRef(function ArrowLeftEndOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftEndOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowLeftOnRectangleIcon';
export const ArrowLeftOnRectangleIconSolid = forwardRef(function ArrowLeftOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftStartOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowLeftStartOnRectangleIcon';
export const ArrowLeftStartOnRectangleIconSolid = forwardRef(function ArrowLeftStartOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftStartOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowLeftIcon';
export const ArrowLeftIconSolid = forwardRef(function ArrowLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowLongDownIcon';
export const ArrowLongDownIconSolid = forwardRef(function ArrowLongDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowLongLeftIcon';
export const ArrowLongLeftIconSolid = forwardRef(function ArrowLongLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowLongRightIcon';
export const ArrowLongRightIconSolid = forwardRef(function ArrowLongRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowLongUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowLongUpIcon';
export const ArrowLongUpIconSolid = forwardRef(function ArrowLongUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowLongUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowPathRoundedSquareIconSolidOriginal from '@heroicons/react/24/solid/ArrowPathRoundedSquareIcon';
export const ArrowPathRoundedSquareIconSolid = forwardRef(function ArrowPathRoundedSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowPathRoundedSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowPathIconSolidOriginal from '@heroicons/react/24/solid/ArrowPathIcon';
export const ArrowPathIconSolid = forwardRef(function ArrowPathIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowPathIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightCircleIconSolidOriginal from '@heroicons/react/24/solid/ArrowRightCircleIcon';
export const ArrowRightCircleIconSolid = forwardRef(function ArrowRightCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightEndOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowRightEndOnRectangleIcon';
export const ArrowRightEndOnRectangleIconSolid = forwardRef(function ArrowRightEndOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightEndOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowRightOnRectangleIcon';
export const ArrowRightOnRectangleIconSolid = forwardRef(function ArrowRightOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightStartOnRectangleIconSolidOriginal from '@heroicons/react/24/solid/ArrowRightStartOnRectangleIcon';
export const ArrowRightStartOnRectangleIconSolid = forwardRef(function ArrowRightStartOnRectangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightStartOnRectangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowRightIcon';
export const ArrowRightIconSolid = forwardRef(function ArrowRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowSmallDownIcon';
export const ArrowSmallDownIconSolid = forwardRef(function ArrowSmallDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowSmallLeftIcon';
export const ArrowSmallLeftIconSolid = forwardRef(function ArrowSmallLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowSmallRightIcon';
export const ArrowSmallRightIconSolid = forwardRef(function ArrowSmallRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowSmallUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowSmallUpIcon';
export const ArrowSmallUpIconSolid = forwardRef(function ArrowSmallUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowSmallUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTopRightOnSquareIconSolidOriginal from '@heroicons/react/24/solid/ArrowTopRightOnSquareIcon';
export const ArrowTopRightOnSquareIconSolid = forwardRef(function ArrowTopRightOnSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTopRightOnSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTrendingDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowTrendingDownIcon';
export const ArrowTrendingDownIconSolid = forwardRef(function ArrowTrendingDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTrendingDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTrendingUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowTrendingUpIcon';
export const ArrowTrendingUpIconSolid = forwardRef(function ArrowTrendingUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTrendingUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnDownLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnDownLeftIcon';
export const ArrowTurnDownLeftIconSolid = forwardRef(function ArrowTurnDownLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnDownLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnDownRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnDownRightIcon';
export const ArrowTurnDownRightIconSolid = forwardRef(function ArrowTurnDownRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnDownRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnLeftDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnLeftDownIcon';
export const ArrowTurnLeftDownIconSolid = forwardRef(function ArrowTurnLeftDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnLeftDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnLeftUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnLeftUpIcon';
export const ArrowTurnLeftUpIconSolid = forwardRef(function ArrowTurnLeftUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnLeftUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnRightDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnRightDownIcon';
export const ArrowTurnRightDownIconSolid = forwardRef(function ArrowTurnRightDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnRightDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnRightUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnRightUpIcon';
export const ArrowTurnRightUpIconSolid = forwardRef(function ArrowTurnRightUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnRightUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnUpLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnUpLeftIcon';
export const ArrowTurnUpLeftIconSolid = forwardRef(function ArrowTurnUpLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnUpLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowTurnUpRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowTurnUpRightIcon';
export const ArrowTurnUpRightIconSolid = forwardRef(function ArrowTurnUpRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowTurnUpRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpCircleIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpCircleIcon';
export const ArrowUpCircleIconSolid = forwardRef(function ArrowUpCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpLeftIcon';
export const ArrowUpLeftIconSolid = forwardRef(function ArrowUpLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpOnSquareStackIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpOnSquareStackIcon';
export const ArrowUpOnSquareStackIconSolid = forwardRef(function ArrowUpOnSquareStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpOnSquareStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpOnSquareIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpOnSquareIcon';
export const ArrowUpOnSquareIconSolid = forwardRef(function ArrowUpOnSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpOnSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpRightIcon';
export const ArrowUpRightIconSolid = forwardRef(function ArrowUpRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpTrayIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpTrayIcon';
export const ArrowUpTrayIconSolid = forwardRef(function ArrowUpTrayIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpTrayIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowUpIcon';
export const ArrowUpIconSolid = forwardRef(function ArrowUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowUturnDownIcon';
export const ArrowUturnDownIconSolid = forwardRef(function ArrowUturnDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowUturnLeftIcon';
export const ArrowUturnLeftIconSolid = forwardRef(function ArrowUturnLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnRightIconSolidOriginal from '@heroicons/react/24/solid/ArrowUturnRightIcon';
export const ArrowUturnRightIconSolid = forwardRef(function ArrowUturnRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowUturnUpIconSolidOriginal from '@heroicons/react/24/solid/ArrowUturnUpIcon';
export const ArrowUturnUpIconSolid = forwardRef(function ArrowUturnUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowUturnUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsPointingInIconSolidOriginal from '@heroicons/react/24/solid/ArrowsPointingInIcon';
export const ArrowsPointingInIconSolid = forwardRef(function ArrowsPointingInIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsPointingInIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsPointingOutIconSolidOriginal from '@heroicons/react/24/solid/ArrowsPointingOutIcon';
export const ArrowsPointingOutIconSolid = forwardRef(function ArrowsPointingOutIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsPointingOutIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsRightLeftIconSolidOriginal from '@heroicons/react/24/solid/ArrowsRightLeftIcon';
export const ArrowsRightLeftIconSolid = forwardRef(function ArrowsRightLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsRightLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ArrowsUpDownIconSolidOriginal from '@heroicons/react/24/solid/ArrowsUpDownIcon';
export const ArrowsUpDownIconSolid = forwardRef(function ArrowsUpDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ArrowsUpDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import AtSymbolIconSolidOriginal from '@heroicons/react/24/solid/AtSymbolIcon';
export const AtSymbolIconSolid = forwardRef(function AtSymbolIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(AtSymbolIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BackspaceIconSolidOriginal from '@heroicons/react/24/solid/BackspaceIcon';
export const BackspaceIconSolid = forwardRef(function BackspaceIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BackspaceIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BackwardIconSolidOriginal from '@heroicons/react/24/solid/BackwardIcon';
export const BackwardIconSolid = forwardRef(function BackwardIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BackwardIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BanknotesIconSolidOriginal from '@heroicons/react/24/solid/BanknotesIcon';
export const BanknotesIconSolid = forwardRef(function BanknotesIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BanknotesIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars2IconSolidOriginal from '@heroicons/react/24/solid/Bars2Icon';
export const Bars2IconSolid = forwardRef(function Bars2IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars2IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3BottomLeftIconSolidOriginal from '@heroicons/react/24/solid/Bars3BottomLeftIcon';
export const Bars3BottomLeftIconSolid = forwardRef(function Bars3BottomLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3BottomLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3BottomRightIconSolidOriginal from '@heroicons/react/24/solid/Bars3BottomRightIcon';
export const Bars3BottomRightIconSolid = forwardRef(function Bars3BottomRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3BottomRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3CenterLeftIconSolidOriginal from '@heroicons/react/24/solid/Bars3CenterLeftIcon';
export const Bars3CenterLeftIconSolid = forwardRef(function Bars3CenterLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3CenterLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars3IconSolidOriginal from '@heroicons/react/24/solid/Bars3Icon';
export const Bars3IconSolid = forwardRef(function Bars3IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars3IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Bars4IconSolidOriginal from '@heroicons/react/24/solid/Bars4Icon';
export const Bars4IconSolid = forwardRef(function Bars4IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Bars4IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BarsArrowDownIconSolidOriginal from '@heroicons/react/24/solid/BarsArrowDownIcon';
export const BarsArrowDownIconSolid = forwardRef(function BarsArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BarsArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BarsArrowUpIconSolidOriginal from '@heroicons/react/24/solid/BarsArrowUpIcon';
export const BarsArrowUpIconSolid = forwardRef(function BarsArrowUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BarsArrowUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery0IconSolidOriginal from '@heroicons/react/24/solid/Battery0Icon';
export const Battery0IconSolid = forwardRef(function Battery0IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery0IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery100IconSolidOriginal from '@heroicons/react/24/solid/Battery100Icon';
export const Battery100IconSolid = forwardRef(function Battery100IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery100IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Battery50IconSolidOriginal from '@heroicons/react/24/solid/Battery50Icon';
export const Battery50IconSolid = forwardRef(function Battery50IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Battery50IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BeakerIconSolidOriginal from '@heroicons/react/24/solid/BeakerIcon';
export const BeakerIconSolid = forwardRef(function BeakerIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BeakerIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellAlertIconSolidOriginal from '@heroicons/react/24/solid/BellAlertIcon';
export const BellAlertIconSolid = forwardRef(function BellAlertIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellAlertIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellSlashIconSolidOriginal from '@heroicons/react/24/solid/BellSlashIcon';
export const BellSlashIconSolid = forwardRef(function BellSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellSnoozeIconSolidOriginal from '@heroicons/react/24/solid/BellSnoozeIcon';
export const BellSnoozeIconSolid = forwardRef(function BellSnoozeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellSnoozeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BellIconSolidOriginal from '@heroicons/react/24/solid/BellIcon';
export const BellIconSolid = forwardRef(function BellIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BellIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoldIconSolidOriginal from '@heroicons/react/24/solid/BoldIcon';
export const BoldIconSolid = forwardRef(function BoldIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoldIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoltSlashIconSolidOriginal from '@heroicons/react/24/solid/BoltSlashIcon';
export const BoltSlashIconSolid = forwardRef(function BoltSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoltSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BoltIconSolidOriginal from '@heroicons/react/24/solid/BoltIcon';
export const BoltIconSolid = forwardRef(function BoltIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BoltIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookOpenIconSolidOriginal from '@heroicons/react/24/solid/BookOpenIcon';
export const BookOpenIconSolid = forwardRef(function BookOpenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookOpenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkSlashIconSolidOriginal from '@heroicons/react/24/solid/BookmarkSlashIcon';
export const BookmarkSlashIconSolid = forwardRef(function BookmarkSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkSquareIconSolidOriginal from '@heroicons/react/24/solid/BookmarkSquareIcon';
export const BookmarkSquareIconSolid = forwardRef(function BookmarkSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BookmarkIconSolidOriginal from '@heroicons/react/24/solid/BookmarkIcon';
export const BookmarkIconSolid = forwardRef(function BookmarkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BookmarkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BriefcaseIconSolidOriginal from '@heroicons/react/24/solid/BriefcaseIcon';
export const BriefcaseIconSolid = forwardRef(function BriefcaseIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BriefcaseIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BugAntIconSolidOriginal from '@heroicons/react/24/solid/BugAntIcon';
export const BugAntIconSolid = forwardRef(function BugAntIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BugAntIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingLibraryIconSolidOriginal from '@heroicons/react/24/solid/BuildingLibraryIcon';
export const BuildingLibraryIconSolid = forwardRef(function BuildingLibraryIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingLibraryIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingOffice2IconSolidOriginal from '@heroicons/react/24/solid/BuildingOffice2Icon';
export const BuildingOffice2IconSolid = forwardRef(function BuildingOffice2IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingOffice2IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingOfficeIconSolidOriginal from '@heroicons/react/24/solid/BuildingOfficeIcon';
export const BuildingOfficeIconSolid = forwardRef(function BuildingOfficeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingOfficeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import BuildingStorefrontIconSolidOriginal from '@heroicons/react/24/solid/BuildingStorefrontIcon';
export const BuildingStorefrontIconSolid = forwardRef(function BuildingStorefrontIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(BuildingStorefrontIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CakeIconSolidOriginal from '@heroicons/react/24/solid/CakeIcon';
export const CakeIconSolid = forwardRef(function CakeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CakeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalculatorIconSolidOriginal from '@heroicons/react/24/solid/CalculatorIcon';
export const CalculatorIconSolid = forwardRef(function CalculatorIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalculatorIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarDateRangeIconSolidOriginal from '@heroicons/react/24/solid/CalendarDateRangeIcon';
export const CalendarDateRangeIconSolid = forwardRef(function CalendarDateRangeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarDateRangeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarDaysIconSolidOriginal from '@heroicons/react/24/solid/CalendarDaysIcon';
export const CalendarDaysIconSolid = forwardRef(function CalendarDaysIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarDaysIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CalendarIconSolidOriginal from '@heroicons/react/24/solid/CalendarIcon';
export const CalendarIconSolid = forwardRef(function CalendarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CalendarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CameraIconSolidOriginal from '@heroicons/react/24/solid/CameraIcon';
export const CameraIconSolid = forwardRef(function CameraIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CameraIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartBarSquareIconSolidOriginal from '@heroicons/react/24/solid/ChartBarSquareIcon';
export const ChartBarSquareIconSolid = forwardRef(function ChartBarSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartBarSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartBarIconSolidOriginal from '@heroicons/react/24/solid/ChartBarIcon';
export const ChartBarIconSolid = forwardRef(function ChartBarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartBarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChartPieIconSolidOriginal from '@heroicons/react/24/solid/ChartPieIcon';
export const ChartPieIconSolid = forwardRef(function ChartPieIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChartPieIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleBottomCenterTextIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleBottomCenterTextIcon';
export const ChatBubbleBottomCenterTextIconSolid = forwardRef(function ChatBubbleBottomCenterTextIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleBottomCenterTextIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleBottomCenterIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleBottomCenterIcon';
export const ChatBubbleBottomCenterIconSolid = forwardRef(function ChatBubbleBottomCenterIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleBottomCenterIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftEllipsisIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleLeftEllipsisIcon';
export const ChatBubbleLeftEllipsisIconSolid = forwardRef(function ChatBubbleLeftEllipsisIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftEllipsisIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftRightIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleLeftRightIcon';
export const ChatBubbleLeftRightIconSolid = forwardRef(function ChatBubbleLeftRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleLeftIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleLeftIcon';
export const ChatBubbleLeftIconSolid = forwardRef(function ChatBubbleLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleOvalLeftEllipsisIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleOvalLeftEllipsisIcon';
export const ChatBubbleOvalLeftEllipsisIconSolid = forwardRef(function ChatBubbleOvalLeftEllipsisIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleOvalLeftEllipsisIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChatBubbleOvalLeftIconSolidOriginal from '@heroicons/react/24/solid/ChatBubbleOvalLeftIcon';
export const ChatBubbleOvalLeftIconSolid = forwardRef(function ChatBubbleOvalLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChatBubbleOvalLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckBadgeIconSolidOriginal from '@heroicons/react/24/solid/CheckBadgeIcon';
export const CheckBadgeIconSolid = forwardRef(function CheckBadgeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckBadgeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckCircleIconSolidOriginal from '@heroicons/react/24/solid/CheckCircleIcon';
export const CheckCircleIconSolid = forwardRef(function CheckCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CheckIconSolidOriginal from '@heroicons/react/24/solid/CheckIcon';
export const CheckIconSolid = forwardRef(function CheckIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CheckIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleDownIconSolidOriginal from '@heroicons/react/24/solid/ChevronDoubleDownIcon';
export const ChevronDoubleDownIconSolid = forwardRef(function ChevronDoubleDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleLeftIconSolidOriginal from '@heroicons/react/24/solid/ChevronDoubleLeftIcon';
export const ChevronDoubleLeftIconSolid = forwardRef(function ChevronDoubleLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleRightIconSolidOriginal from '@heroicons/react/24/solid/ChevronDoubleRightIcon';
export const ChevronDoubleRightIconSolid = forwardRef(function ChevronDoubleRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDoubleUpIconSolidOriginal from '@heroicons/react/24/solid/ChevronDoubleUpIcon';
export const ChevronDoubleUpIconSolid = forwardRef(function ChevronDoubleUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDoubleUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronDownIconSolidOriginal from '@heroicons/react/24/solid/ChevronDownIcon';
export const ChevronDownIconSolid = forwardRef(function ChevronDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronLeftIconSolidOriginal from '@heroicons/react/24/solid/ChevronLeftIcon';
export const ChevronLeftIconSolid = forwardRef(function ChevronLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronRightIconSolidOriginal from '@heroicons/react/24/solid/ChevronRightIcon';
export const ChevronRightIconSolid = forwardRef(function ChevronRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronUpDownIconSolidOriginal from '@heroicons/react/24/solid/ChevronUpDownIcon';
export const ChevronUpDownIconSolid = forwardRef(function ChevronUpDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronUpDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ChevronUpIconSolidOriginal from '@heroicons/react/24/solid/ChevronUpIcon';
export const ChevronUpIconSolid = forwardRef(function ChevronUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ChevronUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CircleStackIconSolidOriginal from '@heroicons/react/24/solid/CircleStackIcon';
export const CircleStackIconSolid = forwardRef(function CircleStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CircleStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentCheckIconSolidOriginal from '@heroicons/react/24/solid/ClipboardDocumentCheckIcon';
export const ClipboardDocumentCheckIconSolid = forwardRef(function ClipboardDocumentCheckIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentCheckIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentListIconSolidOriginal from '@heroicons/react/24/solid/ClipboardDocumentListIcon';
export const ClipboardDocumentListIconSolid = forwardRef(function ClipboardDocumentListIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentListIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardDocumentIconSolidOriginal from '@heroicons/react/24/solid/ClipboardDocumentIcon';
export const ClipboardDocumentIconSolid = forwardRef(function ClipboardDocumentIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardDocumentIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClipboardIconSolidOriginal from '@heroicons/react/24/solid/ClipboardIcon';
export const ClipboardIconSolid = forwardRef(function ClipboardIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClipboardIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ClockIconSolidOriginal from '@heroicons/react/24/solid/ClockIcon';
export const ClockIconSolid = forwardRef(function ClockIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ClockIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudArrowDownIconSolidOriginal from '@heroicons/react/24/solid/CloudArrowDownIcon';
export const CloudArrowDownIconSolid = forwardRef(function CloudArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudArrowUpIconSolidOriginal from '@heroicons/react/24/solid/CloudArrowUpIcon';
export const CloudArrowUpIconSolid = forwardRef(function CloudArrowUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudArrowUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CloudIconSolidOriginal from '@heroicons/react/24/solid/CloudIcon';
export const CloudIconSolid = forwardRef(function CloudIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CloudIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CodeBracketSquareIconSolidOriginal from '@heroicons/react/24/solid/CodeBracketSquareIcon';
export const CodeBracketSquareIconSolid = forwardRef(function CodeBracketSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CodeBracketSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CodeBracketIconSolidOriginal from '@heroicons/react/24/solid/CodeBracketIcon';
export const CodeBracketIconSolid = forwardRef(function CodeBracketIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CodeBracketIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Cog6ToothIconSolidOriginal from '@heroicons/react/24/solid/Cog6ToothIcon';
export const Cog6ToothIconSolid = forwardRef(function Cog6ToothIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Cog6ToothIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Cog8ToothIconSolidOriginal from '@heroicons/react/24/solid/Cog8ToothIcon';
export const Cog8ToothIconSolid = forwardRef(function Cog8ToothIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Cog8ToothIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CogIconSolidOriginal from '@heroicons/react/24/solid/CogIcon';
export const CogIconSolid = forwardRef(function CogIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CogIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CommandLineIconSolidOriginal from '@heroicons/react/24/solid/CommandLineIcon';
export const CommandLineIconSolid = forwardRef(function CommandLineIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CommandLineIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ComputerDesktopIconSolidOriginal from '@heroicons/react/24/solid/ComputerDesktopIcon';
export const ComputerDesktopIconSolid = forwardRef(function ComputerDesktopIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ComputerDesktopIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CpuChipIconSolidOriginal from '@heroicons/react/24/solid/CpuChipIcon';
export const CpuChipIconSolid = forwardRef(function CpuChipIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CpuChipIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CreditCardIconSolidOriginal from '@heroicons/react/24/solid/CreditCardIcon';
export const CreditCardIconSolid = forwardRef(function CreditCardIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CreditCardIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CubeTransparentIconSolidOriginal from '@heroicons/react/24/solid/CubeTransparentIcon';
export const CubeTransparentIconSolid = forwardRef(function CubeTransparentIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CubeTransparentIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CubeIconSolidOriginal from '@heroicons/react/24/solid/CubeIcon';
export const CubeIconSolid = forwardRef(function CubeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CubeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyBangladeshiIconSolidOriginal from '@heroicons/react/24/solid/CurrencyBangladeshiIcon';
export const CurrencyBangladeshiIconSolid = forwardRef(function CurrencyBangladeshiIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyBangladeshiIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyDollarIconSolidOriginal from '@heroicons/react/24/solid/CurrencyDollarIcon';
export const CurrencyDollarIconSolid = forwardRef(function CurrencyDollarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyDollarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyEuroIconSolidOriginal from '@heroicons/react/24/solid/CurrencyEuroIcon';
export const CurrencyEuroIconSolid = forwardRef(function CurrencyEuroIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyEuroIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyPoundIconSolidOriginal from '@heroicons/react/24/solid/CurrencyPoundIcon';
export const CurrencyPoundIconSolid = forwardRef(function CurrencyPoundIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyPoundIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyRupeeIconSolidOriginal from '@heroicons/react/24/solid/CurrencyRupeeIcon';
export const CurrencyRupeeIconSolid = forwardRef(function CurrencyRupeeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyRupeeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CurrencyYenIconSolidOriginal from '@heroicons/react/24/solid/CurrencyYenIcon';
export const CurrencyYenIconSolid = forwardRef(function CurrencyYenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CurrencyYenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CursorArrowRaysIconSolidOriginal from '@heroicons/react/24/solid/CursorArrowRaysIcon';
export const CursorArrowRaysIconSolid = forwardRef(function CursorArrowRaysIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CursorArrowRaysIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import CursorArrowRippleIconSolidOriginal from '@heroicons/react/24/solid/CursorArrowRippleIcon';
export const CursorArrowRippleIconSolid = forwardRef(function CursorArrowRippleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(CursorArrowRippleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DevicePhoneMobileIconSolidOriginal from '@heroicons/react/24/solid/DevicePhoneMobileIcon';
export const DevicePhoneMobileIconSolid = forwardRef(function DevicePhoneMobileIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DevicePhoneMobileIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DeviceTabletIconSolidOriginal from '@heroicons/react/24/solid/DeviceTabletIcon';
export const DeviceTabletIconSolid = forwardRef(function DeviceTabletIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DeviceTabletIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DivideIconSolidOriginal from '@heroicons/react/24/solid/DivideIcon';
export const DivideIconSolid = forwardRef(function DivideIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DivideIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentArrowDownIconSolidOriginal from '@heroicons/react/24/solid/DocumentArrowDownIcon';
export const DocumentArrowDownIconSolid = forwardRef(function DocumentArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentArrowUpIconSolidOriginal from '@heroicons/react/24/solid/DocumentArrowUpIcon';
export const DocumentArrowUpIconSolid = forwardRef(function DocumentArrowUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentArrowUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentChartBarIconSolidOriginal from '@heroicons/react/24/solid/DocumentChartBarIcon';
export const DocumentChartBarIconSolid = forwardRef(function DocumentChartBarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentChartBarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCheckIconSolidOriginal from '@heroicons/react/24/solid/DocumentCheckIcon';
export const DocumentCheckIconSolid = forwardRef(function DocumentCheckIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCheckIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyBangladeshiIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyBangladeshiIcon';
export const DocumentCurrencyBangladeshiIconSolid = forwardRef(function DocumentCurrencyBangladeshiIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyBangladeshiIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyDollarIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyDollarIcon';
export const DocumentCurrencyDollarIconSolid = forwardRef(function DocumentCurrencyDollarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyDollarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyEuroIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyEuroIcon';
export const DocumentCurrencyEuroIconSolid = forwardRef(function DocumentCurrencyEuroIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyEuroIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyPoundIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyPoundIcon';
export const DocumentCurrencyPoundIconSolid = forwardRef(function DocumentCurrencyPoundIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyPoundIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyRupeeIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyRupeeIcon';
export const DocumentCurrencyRupeeIconSolid = forwardRef(function DocumentCurrencyRupeeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyRupeeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentCurrencyYenIconSolidOriginal from '@heroicons/react/24/solid/DocumentCurrencyYenIcon';
export const DocumentCurrencyYenIconSolid = forwardRef(function DocumentCurrencyYenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentCurrencyYenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentDuplicateIconSolidOriginal from '@heroicons/react/24/solid/DocumentDuplicateIcon';
export const DocumentDuplicateIconSolid = forwardRef(function DocumentDuplicateIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentDuplicateIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentMagnifyingGlassIconSolidOriginal from '@heroicons/react/24/solid/DocumentMagnifyingGlassIcon';
export const DocumentMagnifyingGlassIconSolid = forwardRef(function DocumentMagnifyingGlassIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentMagnifyingGlassIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentMinusIconSolidOriginal from '@heroicons/react/24/solid/DocumentMinusIcon';
export const DocumentMinusIconSolid = forwardRef(function DocumentMinusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentMinusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentPlusIconSolidOriginal from '@heroicons/react/24/solid/DocumentPlusIcon';
export const DocumentPlusIconSolid = forwardRef(function DocumentPlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentPlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentTextIconSolidOriginal from '@heroicons/react/24/solid/DocumentTextIcon';
export const DocumentTextIconSolid = forwardRef(function DocumentTextIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentTextIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import DocumentIconSolidOriginal from '@heroicons/react/24/solid/DocumentIcon';
export const DocumentIconSolid = forwardRef(function DocumentIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(DocumentIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisHorizontalCircleIconSolidOriginal from '@heroicons/react/24/solid/EllipsisHorizontalCircleIcon';
export const EllipsisHorizontalCircleIconSolid = forwardRef(function EllipsisHorizontalCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisHorizontalCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisHorizontalIconSolidOriginal from '@heroicons/react/24/solid/EllipsisHorizontalIcon';
export const EllipsisHorizontalIconSolid = forwardRef(function EllipsisHorizontalIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisHorizontalIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EllipsisVerticalIconSolidOriginal from '@heroicons/react/24/solid/EllipsisVerticalIcon';
export const EllipsisVerticalIconSolid = forwardRef(function EllipsisVerticalIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EllipsisVerticalIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EnvelopeOpenIconSolidOriginal from '@heroicons/react/24/solid/EnvelopeOpenIcon';
export const EnvelopeOpenIconSolid = forwardRef(function EnvelopeOpenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EnvelopeOpenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EnvelopeIconSolidOriginal from '@heroicons/react/24/solid/EnvelopeIcon';
export const EnvelopeIconSolid = forwardRef(function EnvelopeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EnvelopeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EqualsIconSolidOriginal from '@heroicons/react/24/solid/EqualsIcon';
export const EqualsIconSolid = forwardRef(function EqualsIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EqualsIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ExclamationCircleIconSolidOriginal from '@heroicons/react/24/solid/ExclamationCircleIcon';
export const ExclamationCircleIconSolid = forwardRef(function ExclamationCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ExclamationCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ExclamationTriangleIconSolidOriginal from '@heroicons/react/24/solid/ExclamationTriangleIcon';
export const ExclamationTriangleIconSolid = forwardRef(function ExclamationTriangleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ExclamationTriangleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeDropperIconSolidOriginal from '@heroicons/react/24/solid/EyeDropperIcon';
export const EyeDropperIconSolid = forwardRef(function EyeDropperIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeDropperIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeSlashIconSolidOriginal from '@heroicons/react/24/solid/EyeSlashIcon';
export const EyeSlashIconSolid = forwardRef(function EyeSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import EyeIconSolidOriginal from '@heroicons/react/24/solid/EyeIcon';
export const EyeIconSolid = forwardRef(function EyeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(EyeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FaceFrownIconSolidOriginal from '@heroicons/react/24/solid/FaceFrownIcon';
export const FaceFrownIconSolid = forwardRef(function FaceFrownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FaceFrownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FaceSmileIconSolidOriginal from '@heroicons/react/24/solid/FaceSmileIcon';
export const FaceSmileIconSolid = forwardRef(function FaceSmileIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FaceSmileIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FilmIconSolidOriginal from '@heroicons/react/24/solid/FilmIcon';
export const FilmIconSolid = forwardRef(function FilmIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FilmIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FingerPrintIconSolidOriginal from '@heroicons/react/24/solid/FingerPrintIcon';
export const FingerPrintIconSolid = forwardRef(function FingerPrintIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FingerPrintIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FireIconSolidOriginal from '@heroicons/react/24/solid/FireIcon';
export const FireIconSolid = forwardRef(function FireIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FireIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FlagIconSolidOriginal from '@heroicons/react/24/solid/FlagIcon';
export const FlagIconSolid = forwardRef(function FlagIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FlagIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderArrowDownIconSolidOriginal from '@heroicons/react/24/solid/FolderArrowDownIcon';
export const FolderArrowDownIconSolid = forwardRef(function FolderArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderMinusIconSolidOriginal from '@heroicons/react/24/solid/FolderMinusIcon';
export const FolderMinusIconSolid = forwardRef(function FolderMinusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderMinusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderOpenIconSolidOriginal from '@heroicons/react/24/solid/FolderOpenIcon';
export const FolderOpenIconSolid = forwardRef(function FolderOpenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderOpenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderPlusIconSolidOriginal from '@heroicons/react/24/solid/FolderPlusIcon';
export const FolderPlusIconSolid = forwardRef(function FolderPlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderPlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FolderIconSolidOriginal from '@heroicons/react/24/solid/FolderIcon';
export const FolderIconSolid = forwardRef(function FolderIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FolderIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ForwardIconSolidOriginal from '@heroicons/react/24/solid/ForwardIcon';
export const ForwardIconSolid = forwardRef(function ForwardIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ForwardIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import FunnelIconSolidOriginal from '@heroicons/react/24/solid/FunnelIcon';
export const FunnelIconSolid = forwardRef(function FunnelIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(FunnelIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GifIconSolidOriginal from '@heroicons/react/24/solid/GifIcon';
export const GifIconSolid = forwardRef(function GifIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GifIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GiftTopIconSolidOriginal from '@heroicons/react/24/solid/GiftTopIcon';
export const GiftTopIconSolid = forwardRef(function GiftTopIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GiftTopIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GiftIconSolidOriginal from '@heroicons/react/24/solid/GiftIcon';
export const GiftIconSolid = forwardRef(function GiftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GiftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAltIconSolidOriginal from '@heroicons/react/24/solid/GlobeAltIcon';
export const GlobeAltIconSolid = forwardRef(function GlobeAltIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAltIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAmericasIconSolidOriginal from '@heroicons/react/24/solid/GlobeAmericasIcon';
export const GlobeAmericasIconSolid = forwardRef(function GlobeAmericasIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAmericasIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeAsiaAustraliaIconSolidOriginal from '@heroicons/react/24/solid/GlobeAsiaAustraliaIcon';
export const GlobeAsiaAustraliaIconSolid = forwardRef(function GlobeAsiaAustraliaIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeAsiaAustraliaIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import GlobeEuropeAfricaIconSolidOriginal from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
export const GlobeEuropeAfricaIconSolid = forwardRef(function GlobeEuropeAfricaIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(GlobeEuropeAfricaIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H1IconSolidOriginal from '@heroicons/react/24/solid/H1Icon';
export const H1IconSolid = forwardRef(function H1IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H1IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H2IconSolidOriginal from '@heroicons/react/24/solid/H2Icon';
export const H2IconSolid = forwardRef(function H2IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H2IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import H3IconSolidOriginal from '@heroicons/react/24/solid/H3Icon';
export const H3IconSolid = forwardRef(function H3IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(H3IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandRaisedIconSolidOriginal from '@heroicons/react/24/solid/HandRaisedIcon';
export const HandRaisedIconSolid = forwardRef(function HandRaisedIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandRaisedIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandThumbDownIconSolidOriginal from '@heroicons/react/24/solid/HandThumbDownIcon';
export const HandThumbDownIconSolid = forwardRef(function HandThumbDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandThumbDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HandThumbUpIconSolidOriginal from '@heroicons/react/24/solid/HandThumbUpIcon';
export const HandThumbUpIconSolid = forwardRef(function HandThumbUpIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HandThumbUpIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HashtagIconSolidOriginal from '@heroicons/react/24/solid/HashtagIcon';
export const HashtagIconSolid = forwardRef(function HashtagIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HashtagIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HeartIconSolidOriginal from '@heroicons/react/24/solid/HeartIcon';
export const HeartIconSolid = forwardRef(function HeartIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HeartIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HomeModernIconSolidOriginal from '@heroicons/react/24/solid/HomeModernIcon';
export const HomeModernIconSolid = forwardRef(function HomeModernIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HomeModernIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import HomeIconSolidOriginal from '@heroicons/react/24/solid/HomeIcon';
export const HomeIconSolid = forwardRef(function HomeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(HomeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import IdentificationIconSolidOriginal from '@heroicons/react/24/solid/IdentificationIcon';
export const IdentificationIconSolid = forwardRef(function IdentificationIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(IdentificationIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxArrowDownIconSolidOriginal from '@heroicons/react/24/solid/InboxArrowDownIcon';
export const InboxArrowDownIconSolid = forwardRef(function InboxArrowDownIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxArrowDownIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxStackIconSolidOriginal from '@heroicons/react/24/solid/InboxStackIcon';
export const InboxStackIconSolid = forwardRef(function InboxStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InboxIconSolidOriginal from '@heroicons/react/24/solid/InboxIcon';
export const InboxIconSolid = forwardRef(function InboxIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InboxIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import InformationCircleIconSolidOriginal from '@heroicons/react/24/solid/InformationCircleIcon';
export const InformationCircleIconSolid = forwardRef(function InformationCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(InformationCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ItalicIconSolidOriginal from '@heroicons/react/24/solid/ItalicIcon';
export const ItalicIconSolid = forwardRef(function ItalicIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ItalicIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import KeyIconSolidOriginal from '@heroicons/react/24/solid/KeyIcon';
export const KeyIconSolid = forwardRef(function KeyIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(KeyIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LanguageIconSolidOriginal from '@heroicons/react/24/solid/LanguageIcon';
export const LanguageIconSolid = forwardRef(function LanguageIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LanguageIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LifebuoyIconSolidOriginal from '@heroicons/react/24/solid/LifebuoyIcon';
export const LifebuoyIconSolid = forwardRef(function LifebuoyIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LifebuoyIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LightBulbIconSolidOriginal from '@heroicons/react/24/solid/LightBulbIcon';
export const LightBulbIconSolid = forwardRef(function LightBulbIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LightBulbIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LinkSlashIconSolidOriginal from '@heroicons/react/24/solid/LinkSlashIcon';
export const LinkSlashIconSolid = forwardRef(function LinkSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LinkSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LinkIconSolidOriginal from '@heroicons/react/24/solid/LinkIcon';
export const LinkIconSolid = forwardRef(function LinkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LinkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ListBulletIconSolidOriginal from '@heroicons/react/24/solid/ListBulletIcon';
export const ListBulletIconSolid = forwardRef(function ListBulletIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ListBulletIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LockClosedIconSolidOriginal from '@heroicons/react/24/solid/LockClosedIcon';
export const LockClosedIconSolid = forwardRef(function LockClosedIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LockClosedIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import LockOpenIconSolidOriginal from '@heroicons/react/24/solid/LockOpenIcon';
export const LockOpenIconSolid = forwardRef(function LockOpenIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(LockOpenIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassCircleIconSolidOriginal from '@heroicons/react/24/solid/MagnifyingGlassCircleIcon';
export const MagnifyingGlassCircleIconSolid = forwardRef(function MagnifyingGlassCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassMinusIconSolidOriginal from '@heroicons/react/24/solid/MagnifyingGlassMinusIcon';
export const MagnifyingGlassMinusIconSolid = forwardRef(function MagnifyingGlassMinusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassMinusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassPlusIconSolidOriginal from '@heroicons/react/24/solid/MagnifyingGlassPlusIcon';
export const MagnifyingGlassPlusIconSolid = forwardRef(function MagnifyingGlassPlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassPlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MagnifyingGlassIconSolidOriginal from '@heroicons/react/24/solid/MagnifyingGlassIcon';
export const MagnifyingGlassIconSolid = forwardRef(function MagnifyingGlassIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MagnifyingGlassIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MapPinIconSolidOriginal from '@heroicons/react/24/solid/MapPinIcon';
export const MapPinIconSolid = forwardRef(function MapPinIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MapPinIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MapIconSolidOriginal from '@heroicons/react/24/solid/MapIcon';
export const MapIconSolid = forwardRef(function MapIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MapIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MegaphoneIconSolidOriginal from '@heroicons/react/24/solid/MegaphoneIcon';
export const MegaphoneIconSolid = forwardRef(function MegaphoneIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MegaphoneIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MicrophoneIconSolidOriginal from '@heroicons/react/24/solid/MicrophoneIcon';
export const MicrophoneIconSolid = forwardRef(function MicrophoneIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MicrophoneIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusCircleIconSolidOriginal from '@heroicons/react/24/solid/MinusCircleIcon';
export const MinusCircleIconSolid = forwardRef(function MinusCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusSmallIconSolidOriginal from '@heroicons/react/24/solid/MinusSmallIcon';
export const MinusSmallIconSolid = forwardRef(function MinusSmallIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusSmallIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MinusIconSolidOriginal from '@heroicons/react/24/solid/MinusIcon';
export const MinusIconSolid = forwardRef(function MinusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MinusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MoonIconSolidOriginal from '@heroicons/react/24/solid/MoonIcon';
export const MoonIconSolid = forwardRef(function MoonIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MoonIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import MusicalNoteIconSolidOriginal from '@heroicons/react/24/solid/MusicalNoteIcon';
export const MusicalNoteIconSolid = forwardRef(function MusicalNoteIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(MusicalNoteIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NewspaperIconSolidOriginal from '@heroicons/react/24/solid/NewspaperIcon';
export const NewspaperIconSolid = forwardRef(function NewspaperIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NewspaperIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NoSymbolIconSolidOriginal from '@heroicons/react/24/solid/NoSymbolIcon';
export const NoSymbolIconSolid = forwardRef(function NoSymbolIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NoSymbolIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import NumberedListIconSolidOriginal from '@heroicons/react/24/solid/NumberedListIcon';
export const NumberedListIconSolid = forwardRef(function NumberedListIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(NumberedListIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaintBrushIconSolidOriginal from '@heroicons/react/24/solid/PaintBrushIcon';
export const PaintBrushIconSolid = forwardRef(function PaintBrushIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaintBrushIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaperAirplaneIconSolidOriginal from '@heroicons/react/24/solid/PaperAirplaneIcon';
export const PaperAirplaneIconSolid = forwardRef(function PaperAirplaneIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaperAirplaneIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PaperClipIconSolidOriginal from '@heroicons/react/24/solid/PaperClipIcon';
export const PaperClipIconSolid = forwardRef(function PaperClipIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PaperClipIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PauseCircleIconSolidOriginal from '@heroicons/react/24/solid/PauseCircleIcon';
export const PauseCircleIconSolid = forwardRef(function PauseCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PauseCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PauseIconSolidOriginal from '@heroicons/react/24/solid/PauseIcon';
export const PauseIconSolid = forwardRef(function PauseIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PauseIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PencilSquareIconSolidOriginal from '@heroicons/react/24/solid/PencilSquareIcon';
export const PencilSquareIconSolid = forwardRef(function PencilSquareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PencilSquareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PencilIconSolidOriginal from '@heroicons/react/24/solid/PencilIcon';
export const PencilIconSolid = forwardRef(function PencilIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PencilIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PercentBadgeIconSolidOriginal from '@heroicons/react/24/solid/PercentBadgeIcon';
export const PercentBadgeIconSolid = forwardRef(function PercentBadgeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PercentBadgeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneArrowDownLeftIconSolidOriginal from '@heroicons/react/24/solid/PhoneArrowDownLeftIcon';
export const PhoneArrowDownLeftIconSolid = forwardRef(function PhoneArrowDownLeftIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneArrowDownLeftIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneArrowUpRightIconSolidOriginal from '@heroicons/react/24/solid/PhoneArrowUpRightIcon';
export const PhoneArrowUpRightIconSolid = forwardRef(function PhoneArrowUpRightIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneArrowUpRightIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneXMarkIconSolidOriginal from '@heroicons/react/24/solid/PhoneXMarkIcon';
export const PhoneXMarkIconSolid = forwardRef(function PhoneXMarkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneXMarkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhoneIconSolidOriginal from '@heroicons/react/24/solid/PhoneIcon';
export const PhoneIconSolid = forwardRef(function PhoneIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhoneIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PhotoIconSolidOriginal from '@heroicons/react/24/solid/PhotoIcon';
export const PhotoIconSolid = forwardRef(function PhotoIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PhotoIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayCircleIconSolidOriginal from '@heroicons/react/24/solid/PlayCircleIcon';
export const PlayCircleIconSolid = forwardRef(function PlayCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayPauseIconSolidOriginal from '@heroicons/react/24/solid/PlayPauseIcon';
export const PlayPauseIconSolid = forwardRef(function PlayPauseIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayPauseIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlayIconSolidOriginal from '@heroicons/react/24/solid/PlayIcon';
export const PlayIconSolid = forwardRef(function PlayIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlayIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusCircleIconSolidOriginal from '@heroicons/react/24/solid/PlusCircleIcon';
export const PlusCircleIconSolid = forwardRef(function PlusCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusSmallIconSolidOriginal from '@heroicons/react/24/solid/PlusSmallIcon';
export const PlusSmallIconSolid = forwardRef(function PlusSmallIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusSmallIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PlusIconSolidOriginal from '@heroicons/react/24/solid/PlusIcon';
export const PlusIconSolid = forwardRef(function PlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PowerIconSolidOriginal from '@heroicons/react/24/solid/PowerIcon';
export const PowerIconSolid = forwardRef(function PowerIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PowerIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PresentationChartBarIconSolidOriginal from '@heroicons/react/24/solid/PresentationChartBarIcon';
export const PresentationChartBarIconSolid = forwardRef(function PresentationChartBarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PresentationChartBarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PresentationChartLineIconSolidOriginal from '@heroicons/react/24/solid/PresentationChartLineIcon';
export const PresentationChartLineIconSolid = forwardRef(function PresentationChartLineIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PresentationChartLineIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PrinterIconSolidOriginal from '@heroicons/react/24/solid/PrinterIcon';
export const PrinterIconSolid = forwardRef(function PrinterIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PrinterIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import PuzzlePieceIconSolidOriginal from '@heroicons/react/24/solid/PuzzlePieceIcon';
export const PuzzlePieceIconSolid = forwardRef(function PuzzlePieceIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(PuzzlePieceIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QrCodeIconSolidOriginal from '@heroicons/react/24/solid/QrCodeIcon';
export const QrCodeIconSolid = forwardRef(function QrCodeIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QrCodeIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QuestionMarkCircleIconSolidOriginal from '@heroicons/react/24/solid/QuestionMarkCircleIcon';
export const QuestionMarkCircleIconSolid = forwardRef(function QuestionMarkCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QuestionMarkCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import QueueListIconSolidOriginal from '@heroicons/react/24/solid/QueueListIcon';
export const QueueListIconSolid = forwardRef(function QueueListIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(QueueListIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RadioIconSolidOriginal from '@heroicons/react/24/solid/RadioIcon';
export const RadioIconSolid = forwardRef(function RadioIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RadioIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ReceiptPercentIconSolidOriginal from '@heroicons/react/24/solid/ReceiptPercentIcon';
export const ReceiptPercentIconSolid = forwardRef(function ReceiptPercentIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ReceiptPercentIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ReceiptRefundIconSolidOriginal from '@heroicons/react/24/solid/ReceiptRefundIcon';
export const ReceiptRefundIconSolid = forwardRef(function ReceiptRefundIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ReceiptRefundIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RectangleGroupIconSolidOriginal from '@heroicons/react/24/solid/RectangleGroupIcon';
export const RectangleGroupIconSolid = forwardRef(function RectangleGroupIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RectangleGroupIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RectangleStackIconSolidOriginal from '@heroicons/react/24/solid/RectangleStackIcon';
export const RectangleStackIconSolid = forwardRef(function RectangleStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RectangleStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RocketLaunchIconSolidOriginal from '@heroicons/react/24/solid/RocketLaunchIcon';
export const RocketLaunchIconSolid = forwardRef(function RocketLaunchIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RocketLaunchIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import RssIconSolidOriginal from '@heroicons/react/24/solid/RssIcon';
export const RssIconSolid = forwardRef(function RssIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(RssIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ScaleIconSolidOriginal from '@heroicons/react/24/solid/ScaleIcon';
export const ScaleIconSolid = forwardRef(function ScaleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ScaleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ScissorsIconSolidOriginal from '@heroicons/react/24/solid/ScissorsIcon';
export const ScissorsIconSolid = forwardRef(function ScissorsIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ScissorsIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ServerStackIconSolidOriginal from '@heroicons/react/24/solid/ServerStackIcon';
export const ServerStackIconSolid = forwardRef(function ServerStackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ServerStackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ServerIconSolidOriginal from '@heroicons/react/24/solid/ServerIcon';
export const ServerIconSolid = forwardRef(function ServerIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ServerIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShareIconSolidOriginal from '@heroicons/react/24/solid/ShareIcon';
export const ShareIconSolid = forwardRef(function ShareIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShareIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShieldCheckIconSolidOriginal from '@heroicons/react/24/solid/ShieldCheckIcon';
export const ShieldCheckIconSolid = forwardRef(function ShieldCheckIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShieldCheckIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShieldExclamationIconSolidOriginal from '@heroicons/react/24/solid/ShieldExclamationIcon';
export const ShieldExclamationIconSolid = forwardRef(function ShieldExclamationIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShieldExclamationIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShoppingBagIconSolidOriginal from '@heroicons/react/24/solid/ShoppingBagIcon';
export const ShoppingBagIconSolid = forwardRef(function ShoppingBagIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShoppingBagIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ShoppingCartIconSolidOriginal from '@heroicons/react/24/solid/ShoppingCartIcon';
export const ShoppingCartIconSolid = forwardRef(function ShoppingCartIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ShoppingCartIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SignalSlashIconSolidOriginal from '@heroicons/react/24/solid/SignalSlashIcon';
export const SignalSlashIconSolid = forwardRef(function SignalSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SignalSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SignalIconSolidOriginal from '@heroicons/react/24/solid/SignalIcon';
export const SignalIconSolid = forwardRef(function SignalIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SignalIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SlashIconSolidOriginal from '@heroicons/react/24/solid/SlashIcon';
export const SlashIconSolid = forwardRef(function SlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SparklesIconSolidOriginal from '@heroicons/react/24/solid/SparklesIcon';
export const SparklesIconSolid = forwardRef(function SparklesIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SparklesIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SpeakerWaveIconSolidOriginal from '@heroicons/react/24/solid/SpeakerWaveIcon';
export const SpeakerWaveIconSolid = forwardRef(function SpeakerWaveIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SpeakerWaveIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SpeakerXMarkIconSolidOriginal from '@heroicons/react/24/solid/SpeakerXMarkIcon';
export const SpeakerXMarkIconSolid = forwardRef(function SpeakerXMarkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SpeakerXMarkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Square2StackIconSolidOriginal from '@heroicons/react/24/solid/Square2StackIcon';
export const Square2StackIconSolid = forwardRef(function Square2StackIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Square2StackIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Square3Stack3DIconSolidOriginal from '@heroicons/react/24/solid/Square3Stack3DIcon';
export const Square3Stack3DIconSolid = forwardRef(function Square3Stack3DIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Square3Stack3DIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import Squares2X2IconSolidOriginal from '@heroicons/react/24/solid/Squares2X2Icon';
export const Squares2X2IconSolid = forwardRef(function Squares2X2IconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(Squares2X2IconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SquaresPlusIconSolidOriginal from '@heroicons/react/24/solid/SquaresPlusIcon';
export const SquaresPlusIconSolid = forwardRef(function SquaresPlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SquaresPlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StarIconSolidOriginal from '@heroicons/react/24/solid/StarIcon';
export const StarIconSolid = forwardRef(function StarIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StarIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StopCircleIconSolidOriginal from '@heroicons/react/24/solid/StopCircleIcon';
export const StopCircleIconSolid = forwardRef(function StopCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StopCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StopIconSolidOriginal from '@heroicons/react/24/solid/StopIcon';
export const StopIconSolid = forwardRef(function StopIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StopIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import StrikethroughIconSolidOriginal from '@heroicons/react/24/solid/StrikethroughIcon';
export const StrikethroughIconSolid = forwardRef(function StrikethroughIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(StrikethroughIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SunIconSolidOriginal from '@heroicons/react/24/solid/SunIcon';
export const SunIconSolid = forwardRef(function SunIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SunIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import SwatchIconSolidOriginal from '@heroicons/react/24/solid/SwatchIcon';
export const SwatchIconSolid = forwardRef(function SwatchIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(SwatchIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TableCellsIconSolidOriginal from '@heroicons/react/24/solid/TableCellsIcon';
export const TableCellsIconSolid = forwardRef(function TableCellsIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TableCellsIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TagIconSolidOriginal from '@heroicons/react/24/solid/TagIcon';
export const TagIconSolid = forwardRef(function TagIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TagIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TicketIconSolidOriginal from '@heroicons/react/24/solid/TicketIcon';
export const TicketIconSolid = forwardRef(function TicketIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TicketIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TrashIconSolidOriginal from '@heroicons/react/24/solid/TrashIcon';
export const TrashIconSolid = forwardRef(function TrashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TrashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TrophyIconSolidOriginal from '@heroicons/react/24/solid/TrophyIcon';
export const TrophyIconSolid = forwardRef(function TrophyIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TrophyIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TruckIconSolidOriginal from '@heroicons/react/24/solid/TruckIcon';
export const TruckIconSolid = forwardRef(function TruckIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TruckIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import TvIconSolidOriginal from '@heroicons/react/24/solid/TvIcon';
export const TvIconSolid = forwardRef(function TvIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(TvIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UnderlineIconSolidOriginal from '@heroicons/react/24/solid/UnderlineIcon';
export const UnderlineIconSolid = forwardRef(function UnderlineIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UnderlineIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserCircleIconSolidOriginal from '@heroicons/react/24/solid/UserCircleIcon';
export const UserCircleIconSolid = forwardRef(function UserCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserGroupIconSolidOriginal from '@heroicons/react/24/solid/UserGroupIcon';
export const UserGroupIconSolid = forwardRef(function UserGroupIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserGroupIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserMinusIconSolidOriginal from '@heroicons/react/24/solid/UserMinusIcon';
export const UserMinusIconSolid = forwardRef(function UserMinusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserMinusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserPlusIconSolidOriginal from '@heroicons/react/24/solid/UserPlusIcon';
export const UserPlusIconSolid = forwardRef(function UserPlusIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserPlusIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UserIconSolidOriginal from '@heroicons/react/24/solid/UserIcon';
export const UserIconSolid = forwardRef(function UserIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UserIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import UsersIconSolidOriginal from '@heroicons/react/24/solid/UsersIcon';
export const UsersIconSolid = forwardRef(function UsersIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(UsersIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VariableIconSolidOriginal from '@heroicons/react/24/solid/VariableIcon';
export const VariableIconSolid = forwardRef(function VariableIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VariableIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VideoCameraSlashIconSolidOriginal from '@heroicons/react/24/solid/VideoCameraSlashIcon';
export const VideoCameraSlashIconSolid = forwardRef(function VideoCameraSlashIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VideoCameraSlashIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import VideoCameraIconSolidOriginal from '@heroicons/react/24/solid/VideoCameraIcon';
export const VideoCameraIconSolid = forwardRef(function VideoCameraIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(VideoCameraIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ViewColumnsIconSolidOriginal from '@heroicons/react/24/solid/ViewColumnsIcon';
export const ViewColumnsIconSolid = forwardRef(function ViewColumnsIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ViewColumnsIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import ViewfinderCircleIconSolidOriginal from '@heroicons/react/24/solid/ViewfinderCircleIcon';
export const ViewfinderCircleIconSolid = forwardRef(function ViewfinderCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(ViewfinderCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WalletIconSolidOriginal from '@heroicons/react/24/solid/WalletIcon';
export const WalletIconSolid = forwardRef(function WalletIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WalletIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WifiIconSolidOriginal from '@heroicons/react/24/solid/WifiIcon';
export const WifiIconSolid = forwardRef(function WifiIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WifiIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WindowIconSolidOriginal from '@heroicons/react/24/solid/WindowIcon';
export const WindowIconSolid = forwardRef(function WindowIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WindowIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WrenchScrewdriverIconSolidOriginal from '@heroicons/react/24/solid/WrenchScrewdriverIcon';
export const WrenchScrewdriverIconSolid = forwardRef(function WrenchScrewdriverIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WrenchScrewdriverIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import WrenchIconSolidOriginal from '@heroicons/react/24/solid/WrenchIcon';
export const WrenchIconSolid = forwardRef(function WrenchIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(WrenchIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import XCircleIconSolidOriginal from '@heroicons/react/24/solid/XCircleIcon';
export const XCircleIconSolid = forwardRef(function XCircleIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(XCircleIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
import XMarkIconSolidOriginal from '@heroicons/react/24/solid/XMarkIcon';
export const XMarkIconSolid = forwardRef(function XMarkIconSolid(_a, ref) {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return _jsx(XMarkIconSolidOriginal, Object.assign({ strokeWidth: "1.5" }, rest, { className: `ndl-icon-svg ${className}`, ref: ref }));
});
//# sourceMappingURL=heroIcons.js.map